<template>
  <div class="cost-diff-detail-page">
    <div class="page-header">
      <div class="header-left">
        <el-button icon="el-icon-arrow-left" @click="goBack">返回</el-button>
        <span class="page-title">成本差异单详情</span>
      </div>
    </div>

    <div v-if="!currentDiff || !currentDiff.diffBillNo" class="loading-container">
      <div style="text-align: center; padding: 50px; color: #909399;">加载中...</div>
    </div>

    <template v-else>
      <!-- 运单信息模块 -->
      <div class="expandable-section">
        <div class="section-header" @click="toggleSection('basic')">
          <span class="section-title">运单信息</span>
          <span class="section-toggle">{{ collapsedSections.basic ? '展开' : '收起' }}
            <i :class="collapsedSections.basic ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
          </span>
        </div>
        <div class="section-content" v-show="!collapsedSections.basic">
          <div class="four-col-grid">
            <div class="grid-item">
              <span class="label">成本差异单号</span>
              <span class="value">{{ currentDiff.diffBillNo || '-' }}</span>
            </div>
            <div class="grid-item">
              <span class="label">运单号</span>
              <span class="value">{{ currentDiff.expressNo || '-' }}</span>
            </div>
            <div class="grid-item">
              <span class="label">账单周期</span>
              <span class="value">{{ currentDiff.billCycle || '-' }}</span>
            </div>
            <div class="grid-item">
              <span class="label">差异原因</span>
              <span class="value">{{ currentDiff.diffReason || '-' }}</span>
            </div>
            <div class="grid-item">
              <span class="label">处理方</span>
              <span class="value">{{ currentDiff.handlerRole || '-' }}</span>
            </div>
            <div class="grid-item">
              <span class="label">处理状态</span>
              <el-tag :type="getStatusType(currentDiff.status)" size="small">{{ currentDiff.status || '-' }}</el-tag>
            </div>
            <div class="grid-item">
              <span class="label">处理人</span>
              <span class="value">{{ currentDiff.handlerName || '-' }}</span>
            </div>
            <div class="grid-item">
              <span class="label">创建时间</span>
              <span class="value">{{ currentDiff.createTime || '-' }}</span>
            </div>
          </div>
        </div>
      </div>

    <!-- 驳回信息模块 -->
    <div v-if="showRejectInfo" class="expandable-section">
      <div class="section-header" @click="toggleSection('reject')">
        <span class="section-title">驳回信息</span>
        <span class="section-toggle">{{ collapsedSections.reject ? '展开' : '收起' }}
          <i :class="collapsedSections.reject ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
        </span>
      </div>
      <div class="section-content" v-show="!collapsedSections.reject">
        <div class="four-col-grid">
          <div class="grid-item">
            <span class="label">驳回原因</span>
            <span class="value">{{ currentDiff.rejectReason }}</span>
          </div>
          <div class="grid-item">
            <span class="label">驳回人</span>
            <span class="value">{{ currentDiff.rejectorName || '-' }}</span>
          </div>
          <div class="grid-item">
            <span class="label">驳回时间</span>
            <span class="value">{{ currentDiff.rejectTime || '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 处理指派信息模块 -->
    <div v-if="showDefaultRuleInfo" class="expandable-section">
      <div class="section-header" @click="toggleSection('assign')">
        <span class="section-title">处理指派信息</span>
        <span class="section-toggle">{{ collapsedSections.assign ? '展开' : '收起' }}
          <i :class="collapsedSections.assign ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
        </span>
      </div>
      <div class="section-content" v-show="!collapsedSections.assign">
        <p>该差异未命中具体规则，由默认规则指派。</p>
        <div class="four-col-grid">
          <div class="grid-item">
            <span class="label">处理方</span>
            <span class="value">{{ currentDiff.handlerRole }}</span>
          </div>
          <div class="grid-item">
            <span class="label">处理人</span>
            <span class="value">{{ currentDiff.handlerName || '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 接口详情和操作日志页签 -->
    <div class="tabs-container">
      <el-tabs v-model="activeTab" type="card" class="detail-tabs">
        <el-tab-pane label="差异详情" name="detail">
          <!-- 差异数据对比模块 -->
          <div class="expandable-section">
            <div class="section-header" @click="toggleSection('compare')">
              <span class="section-title">差异数据对比（原始账单）</span>
              <span class="section-toggle">{{ collapsedSections.compare ? '展开' : '收起' }}
                <i :class="collapsedSections.compare ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
              </span>
            </div>
            <div class="section-content" v-show="!collapsedSections.compare">
              <div class="compare-header">
                <span class="compare-title">差异数据对比（原始账单）</span>
                <el-button type="text" @click="toggleCompareView" size="small">
                  {{ showFullCompare ? '收起多余字段' : '展开全部字段' }}
                </el-button>
              </div>
              <div class="compare-table">
                <el-table :data="displayCompareData" border style="width: 100%" size="small">
                  <el-table-column prop="item" label="对比项" width="150"></el-table-column>
                  <el-table-column prop="baozun" label="宝尊系统" width="150"></el-table-column>
                  <el-table-column prop="transport" label="物流商账单" width="150"></el-table-column>
                  <el-table-column prop="diff" label="差异">
                    <template slot-scope="scope">
                      <span :class="scope.row.diffClass">{{ scope.row.diff }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>

          <!-- 驳回信息模块 -->
          <div v-if="showRejectInfo" class="expandable-section">
            <div class="section-header" @click="toggleSection('reject')">
              <span class="section-title">驳回信息</span>
              <span class="section-toggle">{{ collapsedSections.reject ? '展开' : '收起' }}
                <i :class="collapsedSections.reject ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
              </span>
            </div>
            <div class="section-content" v-show="!collapsedSections.reject">
              <div class="four-col-grid">
                <div class="grid-item">
                  <span class="label">驳回原因</span>
                  <span class="value">{{ currentDiff.rejectReason }}</span>
                </div>
                <div class="grid-item">
                  <span class="label">驳回人</span>
                  <span class="value">{{ currentDiff.rejectorName || '-' }}</span>
                </div>
                <div class="grid-item">
                  <span class="label">驳回时间</span>
                  <span class="value">{{ currentDiff.rejectTime }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 处理指派信息模块 -->
          <div v-if="showAssignInfo" class="expandable-section">
            <div class="section-header" @click="toggleSection('assign')">
              <span class="section-title">处理指派信息</span>
              <span class="section-toggle">{{ collapsedSections.assign ? '展开' : '收起' }}
                <i :class="collapsedSections.assign ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
              </span>
            </div>
            <div class="section-content" v-show="!collapsedSections.assign">
              <div class="four-col-grid">
                <div class="grid-item">
                  <span class="label">指派时间</span>
                  <span class="value">{{ currentDiff.assignTime || '-' }}</span>
                </div>
                <div class="grid-item">
                  <span class="label">指派处理方</span>
                  <span class="value">{{ currentDiff.handlerRole }}</span>
                </div>
                <div class="grid-item">
                  <span class="label">指派处理人</span>
                  <span class="value">{{ currentDiff.handlerName || '-' }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 处理方反馈内容模块 -->
          <div v-if="currentDiff.feedback && currentDiff.status !== '待处理'" class="expandable-section">
            <div class="section-header" @click="toggleSection('feedback')">
              <span class="section-title">处理方反馈内容</span>
              <span class="section-toggle">{{ collapsedSections.feedback ? '展开' : '收起' }}
                <i :class="collapsedSections.feedback ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
              </span>
            </div>
            <div class="section-content" v-show="!collapsedSections.feedback">
              <div v-if="currentDiff.feedback.feedbackType" class="four-col-grid">
                <div class="grid-item">
                  <span class="label">核对结果</span>
                  <span class="value">{{ currentDiff.feedback.feedbackType }}</span>
                </div>
                <div class="grid-item">
                  <span class="label">反馈时间</span>
                  <span class="value">{{ currentDiff.feedback.feedbackTime }}</span>
                </div>
              </div>
              <div v-if="currentDiff.feedback.handlerDesc" class="feedback-desc">
                <span class="label">处理说明</span>
                <p>{{ currentDiff.feedback.handlerDesc }}</p>
              </div>
              <div v-if="currentDiff.feedback.returnBatchNo" class="four-col-grid">
                <div class="grid-item">
                  <span class="label">退货批次号</span>
                  <span class="value">{{ currentDiff.feedback.returnBatchNo }}</span>
                </div>
              </div>
              <div v-if="currentDiff.feedback.attachments && currentDiff.feedback.attachments.length > 0" class="feedback-attachments">
                <span class="label">附件</span>
                <div class="attachment-list">
                  <div v-for="(file, index) in currentDiff.feedback.attachments" :key="index" class="attachment-item">
                    <el-link type="primary">{{ file }}</el-link>
                  </div>
                </div>
              </div>
              <!-- 核对数据子模块 -->
              <div v-if="currentDiff.proofData" class="sub-section">
                <div class="sub-section-header" @click="toggleSection('proof')">
                  <span class="sub-section-title">核对数据</span>
                  <span class="sub-section-toggle">{{ collapsedSections.proof ? '展开' : '收起' }}
                    <i :class="collapsedSections.proof ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
                  </span>
                </div>
                <div class="sub-section-content" v-show="!collapsedSections.proof">
                  <div class="four-col-grid">
                    <div class="grid-item" v-if="currentDiff.proofData.billingWeight">
                      <span class="label">计费重量</span>
                      <span class="value">{{ currentDiff.proofData.billingWeight }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.senderProvince">
                      <span class="label">寄件省</span>
                      <span class="value">{{ currentDiff.proofData.senderProvince }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.senderCity">
                      <span class="label">寄件市</span>
                      <span class="value">{{ currentDiff.proofData.senderCity }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.senderDistrict">
                      <span class="label">寄件区</span>
                      <span class="value">{{ currentDiff.proofData.senderDistrict }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.receiverProvince">
                      <span class="label">收件省</span>
                      <span class="value">{{ currentDiff.proofData.receiverProvince }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.receiverCity">
                      <span class="label">收件市</span>
                      <span class="value">{{ currentDiff.proofData.receiverCity }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.receiverDistrict">
                      <span class="label">收件区</span>
                      <span class="value">{{ currentDiff.proofData.receiverDistrict }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.firstWeightPrice">
                      <span class="label">首重单价</span>
                      <span class="value">{{ currentDiff.proofData.firstWeightPrice }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.continueWeightPrice">
                      <span class="label">续重单价</span>
                      <span class="value">{{ currentDiff.proofData.continueWeightPrice }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.interceptFlag">
                      <span class="label">拦截标识</span>
                      <span class="value">{{ currentDiff.proofData.interceptFlag }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.lightCoefficient">
                      <span class="label">轻抛系数</span>
                      <span class="value">{{ currentDiff.proofData.lightCoefficient }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.actualWeight">
                      <span class="label">实际重量</span>
                      <span class="value">{{ currentDiff.proofData.actualWeight }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.productType">
                      <span class="label">产品类型</span>
                      <span class="value">{{ currentDiff.proofData.productType }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.standardFreight">
                      <span class="label">标准运费</span>
                      <span class="value">{{ currentDiff.proofData.standardFreight }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.discountedFreight">
                      <span class="label">折后运费</span>
                      <span class="value">{{ currentDiff.proofData.discountedFreight }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.declaredValue">
                      <span class="label">声明价值</span>
                      <span class="value">{{ currentDiff.proofData.declaredValue }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.volume">
                      <span class="label">体积</span>
                      <span class="value">{{ currentDiff.proofData.volume }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.length">
                      <span class="label">长</span>
                      <span class="value">{{ currentDiff.proofData.length }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.width">
                      <span class="label">宽</span>
                      <span class="value">{{ currentDiff.proofData.width }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.height">
                      <span class="label">高</span>
                      <span class="value">{{ currentDiff.proofData.height }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.rebate">
                      <span class="label">返利</span>
                      <span class="value">{{ currentDiff.proofData.rebate }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.returnBatchNo">
                      <span class="label">退货批次号</span>
                      <span class="value">{{ currentDiff.proofData.returnBatchNo }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.serviceFee">
                      <span class="label">服务费</span>
                      <span class="value">{{ currentDiff.proofData.serviceFee }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.totalFee">
                      <span class="label">总费用</span>
                      <span class="value">{{ currentDiff.proofData.totalFee }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.brand">
                      <span class="label">品牌</span>
                      <span class="value">{{ currentDiff.proofData.brand }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.discountPromotion">
                      <span class="label">折扣/促销</span>
                      <span class="value">{{ currentDiff.proofData.discountPromotion }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.agreementTerm11">
                      <span class="label">协议条款11</span>
                      <span class="value">{{ currentDiff.proofData.agreementTerm11 }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.agreementTerm12">
                      <span class="label">协议条款12</span>
                      <span class="value">{{ currentDiff.proofData.agreementTerm12 }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.agreementTerm618">
                      <span class="label">协议条款618</span>
                      <span class="value">{{ currentDiff.proofData.agreementTerm618 }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.returnFee">
                      <span class="label">退回费</span>
                      <span class="value">{{ currentDiff.proofData.returnFee }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.springFestivalService">
                      <span class="label">春节不打烊</span>
                      <span class="value">{{ currentDiff.proofData.springFestivalService }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.specialAreaFee">
                      <span class="label">特殊地区加价费用</span>
                      <span class="value">{{ currentDiff.proofData.specialAreaFee }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.otherFee">
                      <span class="label">其他费用</span>
                      <span class="value">{{ currentDiff.proofData.otherFee }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.payableAmountFormula">
                      <span class="label">应付金额计算公式</span>
                      <span class="value">{{ currentDiff.proofData.payableAmountFormula }}</span>
                    </div>
                    <div class="grid-item" v-if="currentDiff.proofData.insuranceFee">
                      <span class="label">保价费</span>
                      <span class="value">{{ currentDiff.proofData.insuranceFee }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 审核记录模块 -->
          <div v-if="showAuditRecords" class="expandable-section">
            <div class="section-header" @click="toggleSection('audit')">
              <span class="section-title">审核记录</span>
              <span class="section-toggle">{{ collapsedSections.audit ? '展开' : '收起' }}
                <i :class="collapsedSections.audit ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
              </span>
            </div>
            <div class="section-content" v-show="!collapsedSections.audit">
              <el-table :data="auditRecords" border style="width: 100%" size="small">
                <el-table-column prop="auditTime" label="审核时间" width="180"></el-table-column>
                <el-table-column prop="auditor" label="审核人" width="100"></el-table-column>
                <el-table-column prop="auditResult" label="审核结果" width="100">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.auditResult === '通过' ? 'success' : 'danger'">{{ scope.row.auditResult }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="auditOpinion" label="审核意见"></el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 审核确认区模块 -->
          <div v-if="showAuditForm" class="expandable-section">
            <div class="section-header" @click="toggleSection('confirm')">
              <span class="section-title">审核确认区</span>
              <span class="section-toggle">{{ collapsedSections.confirm ? '展开' : '收起' }}
                <i :class="collapsedSections.confirm ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
              </span>
            </div>
            <div class="section-content" v-show="!collapsedSections.confirm">
              <div class="four-col-grid">
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>费用确认来源</span>
                  <el-select v-model="auditForm.feeSource" @change="handleFeeSourceChange" class="form-control">
                    <el-option label="宝尊费用" value="baozun"></el-option>
                    <el-option label="物流商费用" value="transport"></el-option>
                    <el-option label="系统重算" value="recalc"></el-option>
                  </el-select>
                </div>
              </div>

              <div class="sub-section-title">基本信息</div>
              <div class="four-col-grid">
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>月结账号</span>
                  <el-input v-model="auditForm.monthlyAccount" class="form-control"></el-input>
                </div>
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>仓库</span>
                  <el-select v-model="auditForm.warehouseCode" placeholder="请选择仓库" filterable clearable class="form-control" @change="onAuditWarehouseChange">
                    <el-option
                      v-for="item in warehouseOptions"
                      :key="item.warehouseCode"
                      :label="item.warehouseName"
                      :value="item.warehouseCode"
                    ></el-option>
                  </el-select>
                </div>
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>店铺</span>
                  <el-select v-model="auditForm.storeCode" placeholder="请选择店铺" filterable clearable class="form-control" @change="onAuditStoreChange">
                    <el-option
                      v-for="item in storeOptions"
                      :key="item.storeCode"
                      :label="item.storeName"
                      :value="item.storeCode"
                    ></el-option>
                  </el-select>
                </div>
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>品牌</span>
                  <el-input v-model="auditForm.brand" placeholder="选择店铺后自动带出" disabled class="form-control"></el-input>
                </div>
                <div class="grid-item">
                  <span class="label">店铺成本中心</span>
                  <el-input v-model="auditForm.storeCostCenter" placeholder="选择店铺后自动带出" disabled class="form-control"></el-input>
                </div>
                <div class="grid-item">
                  <span class="label">园区</span>
                  <el-input v-model="auditForm.parkName" placeholder="选择仓库后自动带出" disabled class="form-control"></el-input>
                </div>
                <div class="grid-item">
                  <span class="label">园区成本中心</span>
                  <el-input v-model="auditForm.parkCostCenter" placeholder="选择仓库后自动带出" disabled class="form-control"></el-input>
                </div>
                <div class="grid-item">
                  <span class="label">产品类型</span>
                  <el-input v-model="auditForm.productType" class="form-control"></el-input>
                </div>
                <div class="grid-item">
                  <span class="label">拦截标识</span>
                  <el-input v-model="auditForm.interceptFlag" class="form-control"></el-input>
                </div>
              </div>

              <div class="audit-opinion">
                <span class="label">备注</span>
                <el-input type="textarea" v-model="auditForm.remark" :rows="2" maxlength="500"></el-input>
              </div>

              <div class="sub-section-title">计费重量与尺寸</div>
              <div class="four-col-grid">
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>计费重量(kg)</span>
                  <el-input-number v-model="auditForm.confirmWeight" :min="0" :step="0.001" @change="recalcFees" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>实际重量(kg)</span>
                  <el-input-number v-model="auditForm.confirmActualWeight" :min="0" :step="0.001" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>长(cm)</span>
                  <el-input-number v-model="auditForm.confirmLength" :min="0" :step="0.01" @change="recalcFees" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>宽(cm)</span>
                  <el-input-number v-model="auditForm.confirmWidth" :min="0" :step="0.01" @change="recalcFees" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>高(cm)</span>
                  <el-input-number v-model="auditForm.confirmHeight" :min="0" :step="0.01" @change="recalcFees" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>体积(cm³)</span>
                  <el-input-number v-model="auditForm.confirmVolume" :min="0" :step="0.000001" @change="recalcFees" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">轻抛系数</span>
                  <el-input-number v-model="auditForm.lightThrowFactor" :min="0" :step="1" @change="recalcFees" class="form-control"></el-input-number>
                </div>
              </div>

              <div class="sub-section-title">寄件省市区</div>
              <div class="four-col-grid">
                <div class="grid-item full-width">
                  <span class="label"><span class="required-mark">*</span>寄件省市区</span>
                  <el-cascader 
                    v-model="senderAddress" 
                    :options="addressOptions" 
                    placeholder="请选择寄件省市区"
                    class="form-control"
                    @change="handleSenderAddressChange"
                  ></el-cascader>
                </div>
              </div>

              <div class="sub-section-title">收件省市区</div>
              <div class="four-col-grid">
                <div class="grid-item full-width">
                  <span class="label"><span class="required-mark">*</span>收件省市区</span>
                  <el-cascader 
                    v-model="receiverAddress" 
                    :options="addressOptions" 
                    placeholder="请选择收件省市区"
                    class="form-control"
                    @change="handleReceiverAddressChange"
                  ></el-cascader>
                </div>
              </div>

              <div class="sub-section-title">费用单价</div>
              <div class="four-col-grid">
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>首重单价(元)</span>
                  <el-input-number v-model="auditForm.firstWeightPrice" :min="0" :step="0.0001" @change="recalcFees" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>续重单价(元)</span>
                  <el-input-number v-model="auditForm.continueWeightPrice" :min="0" :step="0.0001" @change="recalcFees" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">折扣/促销</span>
                  <el-input-number v-model="auditForm.discount" :min="0" :step="0.01" @change="recalcFees" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">声明价值(元)</span>
                  <el-input-number v-model="auditForm.declaredValue" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">返利(元)</span>
                  <el-input-number v-model="auditForm.rebate" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
              </div>

              <div class="sub-section-title">协议条款</div>
              <div class="four-col-grid">
                <div class="grid-item">
                  <span class="label">协议条款11(元)</span>
                  <el-input-number v-model="auditForm.agreementClause11" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">协议条款12(元)</span>
                  <el-input-number v-model="auditForm.agreementClause12" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">协议条款618(元)</span>
                  <el-input-number v-model="auditForm.agreementClause618" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
              </div>

              <div class="sub-section-title">其他费用</div>
              <div class="four-col-grid">
                <div class="grid-item">
                  <span class="label">退回费(元)</span>
                  <el-input-number v-model="auditForm.returnFee" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">春节不打烊(元)</span>
                  <el-input-number v-model="auditForm.springFestivalService" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">特殊地区加价费用(元)</span>
                  <el-input-number v-model="auditForm.specialAreaSurcharge" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">其他费用(元)</span>
                  <el-input-number v-model="auditForm.otherFee" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">服务费(元)</span>
                  <el-input-number v-model="auditForm.serviceFee" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
              </div>

              <div class="sub-section-title">费用项</div>
              <div class="four-col-grid">
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>标准运费(元)</span>
                  <el-input-number v-model="auditForm.standardFreight" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>折后运费(元)</span>
                  <el-input-number v-model="auditForm.discountedFreight" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label">保价费(元)</span>
                  <el-input-number v-model="auditForm.insuranceFee" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
                <div class="grid-item">
                  <span class="label"><span class="required-mark">*</span>总费用(元)</span>
                  <el-input-number v-model="auditForm.totalFee" :min="0" :step="0.01" class="form-control"></el-input-number>
                </div>
              </div>

              <div class="audit-opinion">
                <span class="label">应付金额计算公式</span>
                <el-input type="textarea" v-model="auditForm.payableAmountFormula" :rows="2" maxlength="500"></el-input>
              </div>

              <div class="audit-opinion">
                <span class="label">审核意见</span>
                <el-input type="textarea" v-model="auditForm.auditOpinion" :rows="3" maxlength="500" placeholder="请输入审核意见（选填）"></el-input>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane v-if="fromView !== 'myCC'" label="接口详情" name="interface">
          <div class="tab-content-header">
            <el-button type="primary" icon="el-icon-download" @click="exportInterfaceData">导出</el-button>
          </div>
          <div class="interface-detail">
            <el-table ref="interfaceTable" :data="interfaceDetails" border style="width: 100%" size="small" max-height="500" :default-sort="{prop: 'pushTime', order: 'descending'}">
              <el-table-column prop="expressNo" label="快递单号" width="150"></el-table-column>
              <el-table-column prop="checkResult" label="核对结果" width="100"></el-table-column>
              <el-table-column prop="billDate" label="账单日期" width="100"></el-table-column>
              <el-table-column prop="pushTime" label="推送时间" width="150"></el-table-column>
              <el-table-column prop="batchNo" label="批次号" width="120"></el-table-column>
              <el-table-column prop="remark" label="备注" width="100"></el-table-column>
              <el-table-column prop="monthlyAccount" label="月结账号" width="120"></el-table-column>
              <el-table-column prop="service" label="服务" width="100"></el-table-column>
              <el-table-column prop="billingWeight" label="计费重量(kg)" width="120"></el-table-column>
              <el-table-column prop="senderProvince" label="寄件省" width="100"></el-table-column>
              <el-table-column prop="senderCity" label="寄件市" width="100"></el-table-column>
              <el-table-column prop="senderDistrict" label="寄件区" width="100"></el-table-column>
              <el-table-column prop="receiverProvince" label="收件省" width="100"></el-table-column>
              <el-table-column prop="receiverCity" label="收件市" width="100"></el-table-column>
              <el-table-column prop="receiverDistrict" label="收件区" width="100"></el-table-column>
              <el-table-column prop="firstWeightPrice" label="首重单价(元)" width="120"></el-table-column>
              <el-table-column prop="continueWeightPrice" label="续重单价(元)" width="120"></el-table-column>
              <el-table-column prop="interceptFlag" label="拦截标识" width="100"></el-table-column>
              <el-table-column prop="payableAmountFormula" label="应付金额计算公式" width="180"></el-table-column>
              <el-table-column prop="lightCoefficient" label="轻抛系数" width="100"></el-table-column>
              <el-table-column prop="actualWeight" label="实际重量(kg)" width="120"></el-table-column>
              <el-table-column prop="productType" label="产品类型" width="100"></el-table-column>
              <el-table-column prop="discountPromotion" label="折扣/促销" width="120"></el-table-column>
              <el-table-column prop="standardFreight" label="标准运费(元)" width="120"></el-table-column>
              <el-table-column prop="discountedFreight" label="折后运费(元)" width="120"></el-table-column>
              <el-table-column prop="declaredValue" label="声明价值" width="100"></el-table-column>
              <el-table-column prop="volume" label="体积(立方米)" width="120"></el-table-column>
              <el-table-column prop="length" label="长度(cm)" width="100"></el-table-column>
              <el-table-column prop="width" label="宽度(cm)" width="100"></el-table-column>
              <el-table-column prop="height" label="高度(cm)" width="100"></el-table-column>
              <el-table-column prop="rebate" label="返利(元)" width="100"></el-table-column>
              <el-table-column prop="returnBatchNo" label="退货批次号" width="120"></el-table-column>
              <el-table-column prop="businessConfirm" label="商务确认" width="100"></el-table-column>
              <el-table-column prop="backup1" label="备用1" width="100"></el-table-column>
              <el-table-column prop="backup2" label="备用2" width="100"></el-table-column>
              <el-table-column prop="backup3" label="备用3" width="100"></el-table-column>
              <el-table-column prop="backup4" label="备用4" width="100"></el-table-column>
              <el-table-column prop="backup5" label="备用5" width="100"></el-table-column>
              <el-table-column prop="backup6" label="备用6" width="100"></el-table-column>
              <el-table-column prop="backup7" label="备用7" width="100"></el-table-column>
              <el-table-column prop="backup8" label="备用8" width="100"></el-table-column>
              <el-table-column prop="backup9" label="备用9" width="100"></el-table-column>
              <el-table-column prop="backup10" label="备用10" width="100"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane v-if="fromView !== 'myCC'" label="操作日志" name="logs">
          <div class="tab-content-header">
            <el-button type="primary" icon="el-icon-download" @click="exportOperationLogs">导出</el-button>
          </div>
          <div class="logs-detail">
            <el-table :data="operationLogs" border style="width: 100%" size="small">
              <el-table-column prop="time" label="时间" width="180"></el-table-column>
              <el-table-column prop="operator" label="操作人" width="100"></el-table-column>
              <el-table-column prop="operationType" label="操作类型" width="120"></el-table-column>
              <el-table-column prop="detail" label="详情"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="action-bar">
      <el-button @click="goBack">返回列表</el-button>
      <el-button type="primary" v-if="showHandlerForm && fromView !== 'myCC'" @click="showHandleDialog">{{ showRejectInfo ? '重新处理' : '处理' }}</el-button>
      <el-button type="primary" v-if="canAudit && !showAuditButtons" @click="goAudit">审核</el-button>
      <el-button type="danger" v-if="showAuditButtons" @click="showRejectDialog">驳回</el-button>
      <el-button type="primary" v-if="showAuditButtons" @click="confirmAuditPass">审核通过</el-button>
      <el-button type="text" v-if="canForward && fromView !== 'myCC'" @click="showForwardDialog">转发</el-button>
    </div>

    <!-- 转发弹窗 -->
    <el-dialog :visible="forwardDialogVisible" title="转发任务" width="500px" @close="forwardDialogVisible = false">
      <el-form :model="forwardForm" label-width="100px">
        <el-form-item label="处理方" required>
          <el-select v-model="forwardForm.handlerRole" style="width: 200px;" @change="onHandlerRoleChange">
            <el-option label="物流商" value="物流商" />
            <el-option label="财务" value="财务" />
            <el-option label="IT" value="IT" />
            <el-option label="配送组" value="配送组" />
            <el-option label="KA" value="KA" />
            <el-option label="运营" value="运营" />
          </el-select>
        </el-form-item>
        <el-form-item label="处理人" required>
          <el-select v-model="forwardForm.handlerName" style="width: 200px;" filterable>
            <el-option v-for="user in availableHandlers" :key="user.name" :label="user.name" :value="user.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="转发原因">
          <el-input type="textarea" v-model="forwardForm.reason" :rows="3" maxlength="200" placeholder="请输入转发原因（选填）" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="forwardDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleForward">确认转发</el-button>
      </div>
    </el-dialog>

    <!-- 处理弹窗 -->
    <el-dialog :visible="handleDialogVisible" :title="'处理差异单 - ' + currentDiff.diffBillNo" width="70%" :close-on-click-modal="false" @close="handleDialogVisible = false">
      <div class="handle-form">
        <div v-if="currentDiff.status === '已驳回' && currentDiff.rejectInfo" class="reject-record">
          <div class="reject-record-title">
            <i class="el-icon-warning"></i>
            <span>驳回记录</span>
          </div>
          <div class="reject-record-content">
            <div class="reject-record-item">
              <span class="reject-label">驳回人：</span>
              <span class="reject-value">{{ currentDiff.rejectInfo.rejectUser || currentDiff.rejectPerson || '-' }}</span>
            </div>
            <div class="reject-record-item">
              <span class="reject-label">驳回时间：</span>
              <span class="reject-value">{{ currentDiff.rejectInfo.rejectTime || currentDiff.rejectTime || '-' }}</span>
            </div>
            <div class="reject-record-item">
              <span class="reject-label">驳回原因：</span>
              <span class="reject-value">{{ currentDiff.rejectInfo.rejectReason || currentDiff.rejectReason || '-' }}</span>
            </div>
          </div>
        </div>

        <div class="summary-info">
          <div class="summary-row">
            <span class="summary-label">处理方：</span>
            <span class="summary-value">{{ currentDiff.handlerRole }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">差异原因：</span>
            <span class="summary-value">{{ currentDiff.diffReason }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">快递单号：</span>
            <span class="summary-value">{{ currentDiff.expressNo }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">BZ_品牌：</span>
            <span class="summary-value">{{ currentDiff.bzBrand || '-' }}</span>
          </div>
        </div>

        <el-form :model="handlerForm" label-width="140px">
          <el-form-item label="核对结果" required>
            <span class="required-asterisk">*</span>
            <el-select v-model="handlerForm.feedbackType" @change="handleFeedbackTypeChange">
              <el-option label="确认宝尊费用" value="确认宝尊费用" />
              <el-option label="确认物流商费用" value="确认物流商费用" />
              <el-option label="其他核对结果" value="其他核对结果" />
              <el-option label="补充退货批次号" value="补充退货批次号" />
            </el-select>
          </el-form-item>

          <template v-if="handlerForm.feedbackType === '其他核对结果'">
            <div class="four-col-grid">
              <div class="section-title">必填项</div>
              
              <div class="grid-item">
                <span class="required-asterisk">*</span>
                <span class="label">计费重量(kg)</span>
                <el-input-number v-model="handlerForm.proofData.billingWeight" :precision="3" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="required-asterisk">*</span>
                <span class="label">实际重量(kg)</span>
                <el-input-number v-model="handlerForm.proofData.actualWeight" :precision="3" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="required-asterisk">*</span>
                <span class="label">首重单价(元)</span>
                <el-input-number v-model="handlerForm.proofData.firstWeightPrice" :precision="4" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="required-asterisk">*</span>
                <span class="label">续重单价(元)</span>
                <el-input-number v-model="handlerForm.proofData.continueWeightPrice" :precision="4" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="required-asterisk">*</span>
                <span class="label">标准运费(元)</span>
                <el-input-number v-model="handlerForm.proofData.standardFreight" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="required-asterisk">*</span>
                <span class="label">折后运费(元)</span>
                <el-input-number v-model="handlerForm.proofData.discountedFreight" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="required-asterisk">*</span>
                <span class="label">总费用(元)</span>
                <el-input-number v-model="handlerForm.proofData.totalFee" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="required-asterisk">*</span>
                <span class="label">月结账号</span>
                <el-input v-model="handlerForm.proofData.monthlyAccount" style="width:100%"></el-input>
              </div>
              <div class="grid-item full-width">
                <span class="required-asterisk">*</span>
                <span class="label">寄件省市区</span>
                <el-cascader 
                  v-model="handlerForm.senderAddress" 
                  :options="addressOptions" 
                  placeholder="请选择寄件省市区"
                  style="width:100%"
                  @change="handleHandlerSenderAddressChange"
                ></el-cascader>
              </div>
              <div class="grid-item full-width">
                <span class="required-asterisk">*</span>
                <span class="label">收件省市区</span>
                <el-cascader 
                  v-model="handlerForm.receiverAddress" 
                  :options="addressOptions" 
                  placeholder="请选择收件省市区"
                  style="width:100%"
                  @change="handleHandlerReceiverAddressChange"
                ></el-cascader>
              </div>

              <div class="section-title">非必填项</div>
              
              <div class="grid-item">
                <span class="label">长(cm)</span>
                <el-input-number v-model="handlerForm.proofData.length" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">宽(cm)</span>
                <el-input-number v-model="handlerForm.proofData.width" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">高(cm)</span>
                <el-input-number v-model="handlerForm.proofData.height" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">体积(cm³)</span>
                <el-input-number v-model="handlerForm.proofData.volume" :precision="6" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">轻抛系数</span>
                <el-input-number v-model="handlerForm.proofData.lightThrowFactor" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">折扣/促销(元)</span>
                <el-input-number v-model="handlerForm.proofData.discount" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">协议条款11</span>
                <el-input-number v-model="handlerForm.proofData.agreementClause11" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">协议条款12</span>
                <el-input-number v-model="handlerForm.proofData.agreementClause12" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">协议条款618</span>
                <el-input-number v-model="handlerForm.proofData.agreementClause618" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">退回费</span>
                <el-input-number v-model="handlerForm.proofData.returnFee" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">春节不打烊</span>
                <el-input-number v-model="handlerForm.proofData.springFestivalService" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">特殊地区加价费用(元)</span>
                <el-input-number v-model="handlerForm.proofData.specialAreaSurcharge" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">其他费用(元)</span>
                <el-input-number v-model="handlerForm.proofData.otherFee" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">拦截标识</span>
                <el-select v-model="handlerForm.proofData.interceptFlag" style="width:100%">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </div>
              <div class="grid-item">
                <span class="label">应付金额计算公式</span>
                <el-input v-model="handlerForm.proofData.payableAmountFormula" style="width:100%"></el-input>
              </div>
              <div class="grid-item">
                <span class="label">产品类型</span>
                <el-input v-model="handlerForm.proofData.productType" style="width:100%"></el-input>
              </div>
              <div class="grid-item">
                <span class="label">声明价值(元)</span>
                <el-input-number v-model="handlerForm.proofData.declaredValue" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">返利(元)</span>
                <el-input-number v-model="handlerForm.proofData.rebate" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item">
                <span class="label">保价费(元)</span>
                <el-input-number v-model="handlerForm.proofData.insuranceFee" :precision="2" :min="0" style="width:100%"></el-input-number>
              </div>
              <div class="grid-item full-width">
                <span class="label">备注</span>
                <el-input type="textarea" v-model="handlerForm.proofData.remark" style="width:100%"></el-input>
              </div>
            </div>
          </template>

          <el-form-item label="处理说明">
            <el-input type="textarea" v-model="handlerForm.handlerDesc" :rows="3" maxlength="500" placeholder="请输入处理说明" />
          </el-form-item>

          <el-form-item label="附件">
            <el-upload action="#" :file-list="handlerForm.attachments" :limit="5">
              <el-button size="small" type="primary">上传附件</el-button>
              <span class="upload-tip">支持jpg/png/pdf/excel，单文件≤10MB，最多5个</span>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitHandle">提交处理</el-button>
      </div>
    </el-dialog>

    <!-- 无差异确认弹窗 -->
    <el-dialog :visible="confirmDialogVisible" title="无差异确认" width="500px" @close="confirmDialogVisible = false">
      <div class="confirm-content">
        <p class="confirm-title">确认该差异单已无差异，将彻底关闭？</p>
        <div class="info-grid">
          <div class="info-item">
            <span class="label">差异单号：</span>
            <span class="value">{{ currentDiff.diffBillNo }}</span>
          </div>
          <div class="info-item">
            <span class="label">运单号：</span>
            <span class="value">{{ currentDiff.expressNo }}</span>
          </div>
          <div class="info-item">
            <span class="label">最终确认费用：</span>
            <span class="value">{{ formatCurrency(currentDiff.finalTotalFee || 0) }} 元</span>
          </div>
          <div class="info-item">
            <span class="label">确认费用来源：</span>
            <span class="value">系统重算</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirmDialogVisible = false">取消</el-button>
        <el-button type="success" @click="confirmClose">确认关闭</el-button>
      </div>
    </el-dialog>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CostDiffDetail',
  data() {
    return {
      currentDiff: {
        diffBillNo: '',
        billCycle: '',
        expressNo: '',
        transportName: '',
        baozunWeight: 0,
        transportWeight: 0,
        standardFee: 0,
        transportStandardFee: 0,
        discount: 0,
        transportDiscount: 0,
        baozunFee: 0,
        transportFee: 0,
        serviceFee: 0,
        transportServiceFee: 0,
        diffReason: '',
        handlerRole: '',
        handlerName: '',
        status: '',
        createTime: '',
        feedbackTime: '',
        isDefaultRule: false,
        feedbackType: '',
        handleType: '',
        handlerDesc: '',
        attachments: [],
        proofData: {},
        feedback: {},
        baozunAccount: '',
        transportAccount: '',
        brand: '',
        length: 0,
        width: 0,
        height: 0,
        volume: 0,
        senderProvince: '',
        senderCity: '',
        receiverProvince: '',
        receiverCity: '',
        firstWeightPrice: 0,
        continueWeightPrice: 0,
        insuranceFee: 0
      },
      fromView: '',
      showFullCompare: false,
      collapsedSections: {
        basic: false,
        compare: false,
        reject: false,
        assign: false,
        feedback: false,
        proof: false,
        auditRecords: false,
        audit: false,
        interface: false,
        logs: false
      },
      activeTab: 'detail',
      handlerForm: {
        feedbackType: '',
        confirmedWeight: '',
        returnBatchNo: '',
        handlerDesc: '',
        attachments: [],
        handleType: '',
        red冲Amount: null,
        forwardReason: '',
        senderAddress: [],
        receiverAddress: [],
        proofData: {
          billingWeight: null,
          actualWeight: null,
          length: null,
          width: null,
          height: null,
          volume: null,
          lightThrowFactor: null,
          senderProvince: '',
          senderCity: '',
          senderDistrict: '',
          receiverProvince: '',
          receiverCity: '',
          receiverDistrict: '',
          firstWeightPrice: null,
          continueWeightPrice: null,
          standardFreight: null,
          discount: null,
          agreementClause11: null,
          agreementClause12: null,
          agreementClause618: null,
          returnFee: null,
          springFestivalService: null,
          specialAreaSurcharge: null,
          otherFee: null,
          discountedFreight: null,
          totalFee: null,
          interceptFlag: '否',
          payableAmountFormula: '',
          productType: '',
          declaredValue: null,
          rebate: null,
          monthlyAccount: '',
          remark: ''
        }
      },
      forwardDialogVisible: false,
      handleDialogVisible: false,
      forwardForm: {
        handlerRole: '',
        handlerName: '',
        reason: ''
      },
      availableHandlers: [],
      handlerUsers: {
        '物流商': [{ name: '物流商A' }, { name: '物流商B' }, { name: '物流商C' }],
        '财务': [{ name: '张三' }, { name: '李四' }, { name: '王五' }],
        'IT': [{ name: '赵六' }, { name: '钱七' }, { name: '孙八' }],
        '配送组': [{ name: '周九' }, { name: '吴十' }],
        'KA': [{ name: '郑十一' }, { name: '王十二' }],
        '运营': [{ name: '陈十三' }, { name: '刘十四' }]
      },
      confirmDialogVisible: false,
      rejectReason: '',
      auditMode: false,
      auditForm: {
        feeSource: 'recalc',
        remark: '',
        monthlyAccount: '',
        warehouseCode: '',
        storeCode: '',
        brand: '',
        storeCostCenter: '',
        parkName: '',
        parkCostCenter: '',
        confirmWeight: null,
        confirmActualWeight: null,
        confirmLength: null,
        confirmWidth: null,
        confirmHeight: null,
        confirmVolume: null,
        lightThrowFactor: null,
        senderAddress: [],
        receiverAddress: [],
        firstWeightPrice: 12,
        continueWeightPrice: 5,
        standardFreight: null,
        discount: '',
        agreementClause11: null,
        agreementClause12: null,
        agreementClause618: null,
        returnFee: null,
        springFestivalService: null,
        specialAreaSurcharge: null,
        otherFee: null,
        interceptFlag: '否',
        payableAmountFormula: '',
        productType: '',
        declaredValue: null,
        totalFee: null,
        confirmStandardFreight: '0.00',
        confirmDiscountedFreight: '0.00',
        confirmServiceFee: '0.00',
        confirmTotalFee: '0.00',
        confirmRebate: '0.00',
        auditOpinion: '',
        settlementDecision: ''
      },
      warehouseOptions: [
        { warehouseCode: 'WH-SH-01', warehouseName: '上海青浦一号仓', parkCode: 'PARK-SH-01', parkName: '青浦物流园', parkCostCenter: 'CC-PARK-SH01' },
        { warehouseCode: 'WH-SH-02', warehouseName: '上海松江仓', parkCode: 'PARK-SH-02', parkName: '松江智慧物流园', parkCostCenter: 'CC-PARK-SH02' },
        { warehouseCode: 'WH-JS-01', warehouseName: '苏州昆山花桥仓', parkCode: 'PARK-JS-01', parkName: '昆山花桥物流园', parkCostCenter: 'CC-PARK-JS01' },
        { warehouseCode: 'WH-GD-01', warehouseName: '广州南沙仓', parkCode: 'PARK-GD-01', parkName: '南沙港物流园', parkCostCenter: 'CC-PARK-GD01' },
        { warehouseCode: 'WH-ZJ-01', warehouseName: '杭州余杭仓', parkCode: 'PARK-ZJ-01', parkName: '余杭临平物流园', parkCostCenter: 'CC-PARK-ZJ01' }
      ],
      storeOptions: [
        { storeCode: 'STORE-NIKE-TM', storeName: 'NIKE天猫官方旗舰店', brand: 'NIKE-大陆', costCenter: 'CC-STORE-NIKE01' },
        { storeCode: 'STORE-NIKE-JD', storeName: 'NIKE京东自营旗舰店', brand: 'NIKE-大陆', costCenter: 'CC-STORE-NIKE02' },
        { storeCode: 'STORE-ADI-TM', storeName: 'ADIDAS天猫官方旗舰店', brand: 'ADIDAS-大陆', costCenter: 'CC-STORE-ADI01' },
        { storeCode: 'STORE-ADI-JD', storeName: 'ADIDAS京东自营旗舰店', brand: 'ADIDAS-大陆', costCenter: 'CC-STORE-ADI02' },
        { storeCode: 'STORE-PUMA-DY', storeName: 'PUMA抖音旗舰店', brand: 'PUMA-大陆', costCenter: 'CC-STORE-PUMA01' }
      ],
      provinceList: [
        '北京市', '天津市', '河北省', '山西省', '内蒙古自治区',
        '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省',
        '浙江省', '安徽省', '福建省', '江西省', '山东省',
        '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区',
        '海南省', '重庆市', '四川省', '贵州省', '云南省',
        '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区',
        '新疆维吾尔自治区', '香港特别行政区', '澳门特别行政区', '台湾省'
      ],
      senderAddress: [],
      receiverAddress: [],
      addressOptions: [
        { value: '北京市', label: '北京市', children: [{ value: '北京市', label: '北京市', children: [{ value: '东城区', label: '东城区' }, { value: '西城区', label: '西城区' }, { value: '朝阳区', label: '朝阳区' }, { value: '海淀区', label: '海淀区' }, { value: '丰台区', label: '丰台区' }, { value: '石景山区', label: '石景山区' }] }] },
        { value: '上海市', label: '上海市', children: [{ value: '上海市', label: '上海市', children: [{ value: '黄浦区', label: '黄浦区' }, { value: '徐汇区', label: '徐汇区' }, { value: '长宁区', label: '长宁区' }, { value: '静安区', label: '静安区' }, { value: '普陀区', label: '普陀区' }, { value: '虹口区', label: '虹口区' }, { value: '杨浦区', label: '杨浦区' }, { value: '浦东新区', label: '浦东新区' }] }] },
        { value: '广东省', label: '广东省', children: [{ value: '广州市', label: '广州市', children: [{ value: '天河区', label: '天河区' }, { value: '越秀区', label: '越秀区' }, { value: '海珠区', label: '海珠区' }, { value: '白云区', label: '白云区' }, { value: '黄埔区', label: '黄埔区' }, { value: '番禺区', label: '番禺区' }] }, { value: '深圳市', label: '深圳市', children: [{ value: '福田区', label: '福田区' }, { value: '罗湖区', label: '罗湖区' }, { value: '南山区', label: '南山区' }, { value: '宝安区', label: '宝安区' }, { value: '龙岗区', label: '龙岗区' }, { value: '龙华区', label: '龙华区' }] }, { value: '东莞市', label: '东莞市', children: [{ value: '莞城区', label: '莞城区' }, { value: '南城区', label: '南城区' }, { value: '东城区', label: '东城区' }, { value: '万江区', label: '万江区' }] }] },
        { value: '浙江省', label: '浙江省', children: [{ value: '杭州市', label: '杭州市', children: [{ value: '上城区', label: '上城区' }, { value: '下城区', label: '下城区' }, { value: '西湖区', label: '西湖区' }, { value: '拱墅区', label: '拱墅区' }, { value: '江干区', label: '江干区' }, { value: '滨江区', label: '滨江区' }] }, { value: '宁波市', label: '宁波市', children: [{ value: '海曙区', label: '海曙区' }, { value: '江北区', label: '江北区' }, { value: '北仑区', label: '北仑区' }, { value: '镇海区', label: '镇海区' }, { value: '鄞州区', label: '鄞州区' }] }] },
        { value: '江苏省', label: '江苏省', children: [{ value: '南京市', label: '南京市', children: [{ value: '玄武区', label: '玄武区' }, { value: '秦淮区', label: '秦淮区' }, { value: '鼓楼区', label: '鼓楼区' }, { value: '建邺区', label: '建邺区' }, { value: '栖霞区', label: '栖霞区' }, { value: '雨花台区', label: '雨花台区' }] }, { value: '苏州市', label: '苏州市', children: [{ value: '姑苏区', label: '姑苏区' }, { value: '虎丘区', label: '虎丘区' }, { value: '吴中区', label: '吴中区' }, { value: '相城区', label: '相城区' }, { value: '吴江区', label: '吴江区' }] }] },
        { value: '四川省', label: '四川省', children: [{ value: '成都市', label: '成都市', children: [{ value: '锦江区', label: '锦江区' }, { value: '青羊区', label: '青羊区' }, { value: '金牛区', label: '金牛区' }, { value: '武侯区', label: '武侯区' }, { value: '成华区', label: '成华区' }, { value: '高新区', label: '高新区' }] }] },
        { value: '湖北省', label: '湖北省', children: [{ value: '武汉市', label: '武汉市', children: [{ value: '江岸区', label: '江岸区' }, { value: '江汉区', label: '江汉区' }, { value: '硚口区', label: '硚口区' }, { value: '汉阳区', label: '汉阳区' }, { value: '武昌区', label: '武昌区' }, { value: '洪山区', label: '洪山区' }] }] },
        { value: '湖南省', label: '湖南省', children: [{ value: '长沙市', label: '长沙市', children: [{ value: '芙蓉区', label: '芙蓉区' }, { value: '天心区', label: '天心区' }, { value: '岳麓区', label: '岳麓区' }, { value: '开福区', label: '开福区' }, { value: '雨花区', label: '雨花区' }] }] },
        { value: '河南省', label: '河南省', children: [{ value: '郑州市', label: '郑州市', children: [{ value: '中原区', label: '中原区' }, { value: '二七区', label: '二七区' }, { value: '金水区', label: '金水区' }, { value: '管城回族区', label: '管城回族区' }, { value: '惠济区', label: '惠济区' }] }] },
        { value: '山东省', label: '山东省', children: [{ value: '济南市', label: '济南市', children: [{ value: '历下区', label: '历下区' }, { value: '市中区', label: '市中区' }, { value: '槐荫区', label: '槐荫区' }, { value: '天桥区', label: '天桥区' }, { value: '历城区', label: '历城区' }] }, { value: '青岛市', label: '青岛市', children: [{ value: '市南区', label: '市南区' }, { value: '市北区', label: '市北区' }, { value: '黄岛区', label: '黄岛区' }, { value: '崂山区', label: '崂山区' }, { value: '城阳区', label: '城阳区' }] }] },
        { value: '天津市', label: '天津市', children: [{ value: '天津市', label: '天津市', children: [{ value: '和平区', label: '和平区' }, { value: '河东区', label: '河东区' }, { value: '河西区', label: '河西区' }, { value: '南开区', label: '南开区' }, { value: '河北区', label: '河北区' }, { value: '红桥区', label: '红桥区' }] }] },
        { value: '重庆市', label: '重庆市', children: [{ value: '渝中区', label: '渝中区', children: [{ value: '解放碑街道', label: '解放碑街道' }, { value: '朝天门街道', label: '朝天门街道' }] }, { value: '江北区', label: '江北区', children: [{ value: '江北城街道', label: '江北城街道' }, { value: '寸滩街道', label: '寸滩街道' }] }, { value: '南岸区', label: '南岸区', children: [{ value: '南坪街道', label: '南坪街道' }, { value: '弹子石街道', label: '弹子石街道' }] }] },
        { value: '安徽省', label: '安徽省', children: [{ value: '合肥市', label: '合肥市', children: [{ value: '瑶海区', label: '瑶海区' }, { value: '庐阳区', label: '庐阳区' }, { value: '蜀山区', label: '蜀山区' }, { value: '包河区', label: '包河区' }] }] },
        { value: '福建省', label: '福建省', children: [{ value: '福州市', label: '福州市', children: [{ value: '鼓楼区', label: '鼓楼区' }, { value: '台江区', label: '台江区' }, { value: '仓山区', label: '仓山区' }, { value: '晋安区', label: '晋安区' }] }, { value: '厦门市', label: '厦门市', children: [{ value: '思明区', label: '思明区' }, { value: '湖里区', label: '湖里区' }, { value: '集美区', label: '集美区' }, { value: '海沧区', label: '海沧区' }] }] },
        { value: '江西省', label: '江西省', children: [{ value: '南昌市', label: '南昌市', children: [{ value: '东湖区', label: '东湖区' }, { value: '西湖区', label: '西湖区' }, { value: '青云谱区', label: '青云谱区' }, { value: '青山湖区', label: '青山湖区' }] }] },
        { value: '广西壮族自治区', label: '广西壮族自治区', children: [{ value: '南宁市', label: '南宁市', children: [{ value: '兴宁区', label: '兴宁区' }, { value: '青秀区', label: '青秀区' }, { value: '江南区', label: '江南区' }, { value: '西乡塘区', label: '西乡塘区' }] }] },
        { value: '云南省', label: '云南省', children: [{ value: '昆明市', label: '昆明市', children: [{ value: '五华区', label: '五华区' }, { value: '盘龙区', label: '盘龙区' }, { value: '官渡区', label: '官渡区' }, { value: '西山区', label: '西山区' }] }] },
        { value: '陕西省', label: '陕西省', children: [{ value: '西安市', label: '西安市', children: [{ value: '新城区', label: '新城区' }, { value: '碑林区', label: '碑林区' }, { value: '莲湖区', label: '莲湖区' }, { value: '雁塔区', label: '雁塔区' }, { value: '未央区', label: '未央区' }] }] },
        { value: '辽宁省', label: '辽宁省', children: [{ value: '沈阳市', label: '沈阳市', children: [{ value: '和平区', label: '和平区' }, { value: '沈河区', label: '沈河区' }, { value: '大东区', label: '大东区' }, { value: '皇姑区', label: '皇姑区' }, { value: '铁西区', label: '铁西区' }] }, { value: '大连市', label: '大连市', children: [{ value: '中山区', label: '中山区' }, { value: '西岗区', label: '西岗区' }, { value: '沙河口区', label: '沙河口区' }, { value: '甘井子区', label: '甘井子区' }] }] },
        { value: '黑龙江省', label: '黑龙江省', children: [{ value: '哈尔滨市', label: '哈尔滨市', children: [{ value: '道里区', label: '道里区' }, { value: '南岗区', label: '南岗区' }, { value: '道外区', label: '道外区' }, { value: '香坊区', label: '香坊区' }] }] },
        { value: '吉林省', label: '吉林省', children: [{ value: '长春市', label: '长春市', children: [{ value: '朝阳区', label: '朝阳区' }, { value: '南关区', label: '南关区' }, { value: '宽城区', label: '宽城区' }, { value: '二道区', label: '二道区' }, { value: '绿园区', label: '绿园区' }] }] },
        { value: '内蒙古自治区', label: '内蒙古自治区', children: [{ value: '呼和浩特市', label: '呼和浩特市', children: [{ value: '新城区', label: '新城区' }, { value: '回民区', label: '回民区' }, { value: '玉泉区', label: '玉泉区' }, { value: '赛罕区', label: '赛罕区' }] }] },
        { value: '山西省', label: '山西省', children: [{ value: '太原市', label: '太原市', children: [{ value: '小店区', label: '小店区' }, { value: '迎泽区', label: '迎泽区' }, { value: '杏花岭区', label: '杏花岭区' }, { value: '尖草坪区', label: '尖草坪区' }] }] },
        { value: '河北省', label: '河北省', children: [{ value: '石家庄市', label: '石家庄市', children: [{ value: '长安区', label: '长安区' }, { value: '桥西区', label: '桥西区' }, { value: '新华区', label: '新华区' }, { value: '裕华区', label: '裕华区' }] }] },
        { value: '贵州省', label: '贵州省', children: [{ value: '贵阳市', label: '贵阳市', children: [{ value: '云岩区', label: '云岩区' }, { value: '南明区', label: '南明区' }, { value: '花溪区', label: '花溪区' }, { value: '乌当区', label: '乌当区' }] }] },
        { value: '新疆维吾尔自治区', label: '新疆维吾尔自治区', children: [{ value: '乌鲁木齐市', label: '乌鲁木齐市', children: [{ value: '天山区', label: '天山区' }, { value: '沙依巴克区', label: '沙依巴克区' }, { value: '新市区', label: '新市区' }, { value: '水磨沟区', label: '水磨沟区' }] }] },
        { value: '甘肃省', label: '甘肃省', children: [{ value: '兰州市', label: '兰州市', children: [{ value: '城关区', label: '城关区' }, { value: '七里河区', label: '七里河区' }, { value: '西固区', label: '西固区' }, { value: '安宁区', label: '安宁区' }] }] },
        { value: '宁夏回族自治区', label: '宁夏回族自治区', children: [{ value: '银川市', label: '银川市', children: [{ value: '兴庆区', label: '兴庆区' }, { value: '西夏区', label: '西夏区' }, { value: '金凤区', label: '金凤区' }] }] },
        { value: '青海省', label: '青海省', children: [{ value: '西宁市', label: '西宁市', children: [{ value: '城东区', label: '城东区' }, { value: '城中区', label: '城中区' }, { value: '城西区', label: '城西区' }, { value: '城北区', label: '城北区' }] }] },
        { value: '西藏自治区', label: '西藏自治区', children: [{ value: '拉萨市', label: '拉萨市', children: [{ value: '城关区', label: '城关区' }, { value: '堆龙德庆区', label: '堆龙德庆区' }] }] },
        { value: '海南省', label: '海南省', children: [{ value: '海口市', label: '海口市', children: [{ value: '秀英区', label: '秀英区' }, { value: '龙华区', label: '龙华区' }, { value: '琼山区', label: '琼山区' }, { value: '美兰区', label: '美兰区' }] }, { value: '三亚市', label: '三亚市', children: [{ value: '海棠区', label: '海棠区' }, { value: '吉阳区', label: '吉阳区' }, { value: '天涯区', label: '天涯区' }, { value: '崖州区', label: '崖州区' }] }] },
        { value: '香港特别行政区', label: '香港特别行政区', children: [{ value: '香港', label: '香港', children: [{ value: '香港岛', label: '香港岛' }, { value: '九龙', label: '九龙' }, { value: '新界', label: '新界' }] }] },
        { value: '澳门特别行政区', label: '澳门特别行政区', children: [{ value: '澳门', label: '澳门', children: [{ value: '澳门半岛', label: '澳门半岛' }, { value: '氹仔岛', label: '氹仔岛' }, { value: '路环岛', label: '路环岛' }] }] },
        { value: '台湾省', label: '台湾省', children: [{ value: '台北市', label: '台北市', children: [{ value: '中正区', label: '中正区' }, { value: '大同区', label: '大同区' }, { value: '中山区', label: '中山区' }, { value: '松山区', label: '松山区' }] }] }
      ],
      currentUserRole: '管理员',
      operationLogs: [
        { time: '2024-07-01 09:30:00', operator: '系统', operationType: '生成差异单', detail: '差异原因:计费重量校验' },
        { time: '2024-07-02 11:15', operator: '赵六', operationType: '提交处理反馈', detail: '反馈类型:其他核对结果' },
        { time: '2024-07-02 16:00', operator: '钱七', operationType: '财务审核通过', detail: '' },
        { time: '2024-07-03 10:00', operator: '钱七', operationType: '无差异确认', detail: '单据关闭' }
      ],
      auditRecords: [{ auditTime: '2024-07-02 16:00', auditor: '钱七', auditResult: '审核通过', auditOpinion: '通过' }],
      interfaceDetails: [
        {
          expressNo: 'SF5192529203170',
          checkResult: '正常',
          billDate: '2024-07',
          pushTime: '2024-07-03 14:30:00',
          batchNo: 'PC202407001',
          remark: '正常',
          monthlyAccount: '8888888888',
          service: '标准快递',
          billingWeight: 1.5,
          senderProvince: '上海市',
          senderCity: '上海市',
          senderDistrict: '浦东新区',
          receiverProvince: '北京市',
          receiverCity: '北京市',
          receiverDistrict: '朝阳区',
          firstWeightPrice: 12.00,
          continueWeightPrice: 5.00,
          interceptFlag: '否',
          payableAmountFormula: '首重+续重*(计费重量-1)',
          lightCoefficient: 6000,
          actualWeight: 1.45,
          productType: '标准快递',
          discountPromotion: '新客户9折',
          standardFreight: 17.50,
          discountedFreight: 15.75,
          declaredValue: '1000',
          volume: 0.02,
          length: 30,
          width: 20,
          height: 15,
          rebate: 0.50,
          returnBatchNo: '',
          businessConfirm: '是',
          backup1: '',
          backup2: '',
          backup3: '',
          backup4: '',
          backup5: '',
          backup6: '',
          backup7: '',
          backup8: '',
          backup9: '',
          backup10: ''
        },
        {
          expressNo: 'SF5192529203171',
          checkResult: '差异',
          billDate: '2024-07',
          pushTime: '2024-07-03 10:15:00',
          batchNo: 'PC202407002',
          remark: '重量差异',
          monthlyAccount: '8888888888',
          service: '标准快递',
          billingWeight: 2.0,
          senderProvince: '上海市',
          senderCity: '上海市',
          senderDistrict: '静安区',
          receiverProvince: '广东省',
          receiverCity: '深圳市',
          receiverDistrict: '南山区',
          firstWeightPrice: 12.00,
          continueWeightPrice: 6.00,
          interceptFlag: '否',
          payableAmountFormula: '首重+续重*(计费重量-1)',
          lightCoefficient: 6000,
          actualWeight: 1.95,
          productType: '标准快递',
          discountPromotion: '会员85折',
          standardFreight: 24.00,
          discountedFreight: 20.40,
          declaredValue: '2000',
          volume: 0.03,
          length: 40,
          width: 25,
          height: 20,
          rebate: 0.80,
          returnBatchNo: '',
          businessConfirm: '是',
          backup1: '',
          backup2: '',
          backup3: '',
          backup4: '',
          backup5: '',
          backup6: '',
          backup7: '',
          backup8: '',
          backup9: '',
          backup10: ''
        },
        {
          expressNo: 'SF5192529203172',
          checkResult: '正常',
          billDate: '2024-07',
          pushTime: '2024-07-02 16:45:00',
          batchNo: 'PC202407003',
          remark: '正常',
          monthlyAccount: '8888888888',
          service: '特惠快递',
          billingWeight: 0.5,
          senderProvince: '浙江省',
          senderCity: '杭州市',
          senderDistrict: '西湖区',
          receiverProvince: '江苏省',
          receiverCity: '南京市',
          receiverDistrict: '鼓楼区',
          firstWeightPrice: 10.00,
          continueWeightPrice: 4.00,
          interceptFlag: '否',
          payableAmountFormula: '首重',
          lightCoefficient: 6000,
          actualWeight: 0.48,
          productType: '特惠快递',
          discountPromotion: '',
          standardFreight: 12.00,
          discountedFreight: 10.80,
          declaredValue: '500',
          volume: 0.005,
          length: 20,
          width: 15,
          height: 10,
          rebate: 0.30,
          returnBatchNo: '',
          businessConfirm: '否',
          backup1: '',
          backup2: '',
          backup3: '',
          backup4: '',
          backup5: '',
          backup6: '',
          backup7: '',
          backup8: '',
          backup9: '',
          backup10: ''
        }
      ]
    }
  },
  computed: {
    isAuditor() { return this.currentUserRole === '财务' },
    isRed冲运单() { return this.currentDiff && this.currentDiff.diffReason === '红冲运单' && this.currentDiff.handlerRole === '财务' },
    canHandle() {
      if (!this.currentDiff) return false
      const canHandleStatus = ['待处理', '已驳回']
      if (!canHandleStatus.includes(this.currentDiff.status)) return false
      if (this.currentUserRole === '管理员') return true
      if (this.currentUserRole === '财务' && !this.isRed冲运单) return false
      if (this.currentDiff.handlerRole === this.currentUserRole) return true
      if (this.currentDiff.handlerName && this.currentDiff.handlerName === '当前用户') return true
      return false
    },
    canAudit() { return this.currentDiff && this.currentDiff.status === '已处理' && (this.currentUserRole === '财务' || this.currentUserRole === '管理员') },
    showRejectInfo() { return this.currentDiff && this.currentDiff.status === '已驳回' && this.canHandle },
    showHandlerForm() { return this.canHandle && this.currentDiff && (this.currentDiff.status === '待处理' || this.currentDiff.status === '已驳回') },
    showHandlerFeedback() {
      if (!this.currentDiff) return false
      const readStatus = ['已处理', '审核通过', '已关闭']
      if (this.canHandle && readStatus.includes(this.currentDiff.status)) return true
      if (this.canAudit && this.currentDiff.status === '已处理') return true
      if (this.isAuditor && this.currentDiff.feedback && this.currentDiff.status === '已处理') return true
      if (this.currentUserRole === 'CC' && this.currentDiff.feedback && this.currentDiff.status !== '待处理') return true
      if (this.currentDiff.status === '已处理' && this.currentDiff.feedback) return true
      return false
    },
    showDefaultRuleInfo() { return this.currentDiff.isDefaultRule === true },
    showAssignInfo() { return false },
    showAuditSection() { return this.canAudit || this.auditMode },
    showAuditButtons() { return this.auditMode && this.canAudit },
    showAuditForm() { return this.auditMode && this.canAudit },
    isSettlementSystemNotExist() { return this.currentDiff.diffReason === '结算系统不存在' },
    showAuditRecords() {
      const showRecordStatus = ['已驳回', '审核通过', '已关闭']
      if (this.isAuditor && showRecordStatus.includes(this.currentDiff.status)) return true
      if (this.currentUserRole === 'CC' && showRecordStatus.includes(this.currentDiff.status)) return true
      if (this.canHandle && showRecordStatus.includes(this.currentDiff.status)) return true
      return false
    },
    canForward() {
      if (!this.currentDiff.status || this.currentDiff.status === '已关闭') return false
      if (this.currentUserRole === '财务') {
        return this.currentDiff.status === '待处理'
      }
      if (this.canHandle && this.currentDiff.status === '待处理') {
        return true
      }
      return false
    },
    compareData() {
      console.log('compareData computed called, currentDiff:', this.currentDiff)
      const data = [
        { item: '月结账号', baozun: this.currentDiff.baozunAccount || '-', transport: this.currentDiff.transportAccount || '-', diff: this.getTextDiff(this.currentDiff.baozunAccount, this.currentDiff.transportAccount), diffClass: this.getTextDiffClass(this.currentDiff.baozunAccount, this.currentDiff.transportAccount), isFeeField: false },
        { item: '产品类型名称', baozun: this.currentDiff.productTypeName || '-', transport: this.currentDiff.transportProductType || '-', diff: this.getTextDiff(this.currentDiff.productTypeName, this.currentDiff.transportProductType), diffClass: this.getTextDiffClass(this.currentDiff.productTypeName, this.currentDiff.transportProductType), isFeeField: false },
        { item: '付款方式', baozun: this.currentDiff.paymentMethod || '-', transport: this.currentDiff.transportPaymentMethod || '-', diff: this.getTextDiff(this.currentDiff.paymentMethod, this.currentDiff.transportPaymentMethod), diffClass: this.getTextDiffClass(this.currentDiff.paymentMethod, this.currentDiff.transportPaymentMethod), isFeeField: false },
        { item: '计费重量(kg)', baozun: this.currentDiff.baozunWeight || '-', transport: this.currentDiff.transportWeight || '-', diff: this.formatDiff(this.currentDiff.transportWeight - this.currentDiff.baozunWeight), diffClass: this.getDiffClass(this.currentDiff.transportWeight - this.currentDiff.baozunWeight), isFeeField: false },
        { item: '实际重量(kg)', baozun: this.currentDiff.actualWeight || '-', transport: this.currentDiff.transportActualWeight || '-', diff: this.formatDiff(this.currentDiff.transportActualWeight - this.currentDiff.actualWeight), diffClass: this.getDiffClass(this.currentDiff.transportActualWeight - this.currentDiff.actualWeight), isFeeField: false },
        { item: '长(cm)', baozun: this.currentDiff.length || '-', transport: this.currentDiff.transportLength || '-', diff: this.formatDiff(this.currentDiff.transportLength - this.currentDiff.length), diffClass: this.getDiffClass(this.currentDiff.transportLength - this.currentDiff.length), isFeeField: false },
        { item: '宽(cm)', baozun: this.currentDiff.width || '-', transport: this.currentDiff.transportWidth || '-', diff: this.formatDiff(this.currentDiff.transportWidth - this.currentDiff.width), diffClass: this.getDiffClass(this.currentDiff.transportWidth - this.currentDiff.width), isFeeField: false },
        { item: '高(cm)', baozun: this.currentDiff.height || '-', transport: this.currentDiff.transportHeight || '-', diff: this.formatDiff(this.currentDiff.transportHeight - this.currentDiff.height), diffClass: this.getDiffClass(this.currentDiff.transportHeight - this.currentDiff.height), isFeeField: false },
        { item: '体积(cm³)', baozun: this.currentDiff.volume || '-', transport: this.currentDiff.transportVolume || '-', diff: this.formatDiff(this.currentDiff.transportVolume - this.currentDiff.volume), diffClass: this.getDiffClass(this.currentDiff.transportVolume - this.currentDiff.volume), isFeeField: false },
        { item: '体积重(kg)', baozun: this.currentDiff.volumeWeight || '-', transport: this.currentDiff.transportVolumeWeight || '-', diff: this.formatDiff(this.currentDiff.transportVolumeWeight - this.currentDiff.volumeWeight), diffClass: this.getDiffClass(this.currentDiff.transportVolumeWeight - this.currentDiff.volumeWeight), isFeeField: false },
        { item: '轻抛系数', baozun: this.currentDiff.lightCoefficient || '-', transport: this.currentDiff.transportLightCoefficient || '-', diff: this.formatDiff(this.currentDiff.transportLightCoefficient - this.currentDiff.lightCoefficient), diffClass: this.getDiffClass(this.currentDiff.transportLightCoefficient - this.currentDiff.lightCoefficient), isFeeField: false },
        { item: '始发省', baozun: this.currentDiff.originProvince || '-', transport: this.currentDiff.transportOriginProvince || '-', diff: this.getTextDiff(this.currentDiff.originProvince, this.currentDiff.transportOriginProvince), diffClass: this.getTextDiffClass(this.currentDiff.originProvince, this.currentDiff.transportOriginProvince), isFeeField: false },
        { item: '始发市', baozun: this.currentDiff.originCity || '-', transport: this.currentDiff.transportOriginCity || '-', diff: this.getTextDiff(this.currentDiff.originCity, this.currentDiff.transportOriginCity), diffClass: this.getTextDiffClass(this.currentDiff.originCity, this.currentDiff.transportOriginCity), isFeeField: false },
        { item: '始发区', baozun: this.currentDiff.originDistrict || '-', transport: this.currentDiff.transportOriginDistrict || '-', diff: this.getTextDiff(this.currentDiff.originDistrict, this.currentDiff.transportOriginDistrict), diffClass: this.getTextDiffClass(this.currentDiff.originDistrict, this.currentDiff.transportOriginDistrict), isFeeField: false },
        { item: '目的省', baozun: this.currentDiff.destProvince || '-', transport: this.currentDiff.transportDestProvince || '-', diff: this.getTextDiff(this.currentDiff.destProvince, this.currentDiff.transportDestProvince), diffClass: this.getTextDiffClass(this.currentDiff.destProvince, this.currentDiff.transportDestProvince), isFeeField: false },
        { item: '目的市', baozun: this.currentDiff.destCity || '-', transport: this.currentDiff.transportDestCity || '-', diff: this.getTextDiff(this.currentDiff.destCity, this.currentDiff.transportDestCity), diffClass: this.getTextDiffClass(this.currentDiff.destCity, this.currentDiff.transportDestCity), isFeeField: false },
        { item: '目的区', baozun: this.currentDiff.destDistrict || '-', transport: this.currentDiff.transportDestDistrict || '-', diff: this.getTextDiff(this.currentDiff.destDistrict, this.currentDiff.transportDestDistrict), diffClass: this.getTextDiffClass(this.currentDiff.destDistrict, this.currentDiff.transportDestDistrict), isFeeField: false },
        { item: '首重单价(元)', baozun: this.formatCurrency(this.currentDiff.firstWeightPrice), transport: this.formatCurrency(this.currentDiff.transportFirstWeightPrice), diff: this.formatCurrency(this.currentDiff.transportFirstWeightPrice - this.currentDiff.firstWeightPrice), diffClass: this.getDiffClass(this.currentDiff.transportFirstWeightPrice - this.currentDiff.firstWeightPrice), isFeeField: true },
        { item: '续重单价(元)', baozun: this.formatCurrency(this.currentDiff.continueWeightPrice), transport: this.formatCurrency(this.currentDiff.transportContinueWeightPrice), diff: this.formatCurrency(this.currentDiff.transportContinueWeightPrice - this.currentDiff.continueWeightPrice), diffClass: this.getDiffClass(this.currentDiff.transportContinueWeightPrice - this.currentDiff.continueWeightPrice), isFeeField: true },
        { item: '标准运费(元)', baozun: this.formatCurrency(this.currentDiff.standardFee), transport: this.formatCurrency(this.currentDiff.transportStandardFee), diff: this.formatCurrency(this.currentDiff.transportStandardFee - this.currentDiff.standardFee), diffClass: this.getDiffClass(this.currentDiff.transportStandardFee - this.currentDiff.standardFee), isFeeField: true },
        { item: '折扣', baozun: this.currentDiff.discount || '-', transport: this.currentDiff.transportDiscount || '-', diff: this.formatDiff(this.currentDiff.transportDiscount - this.currentDiff.discount), diffClass: this.getDiffClass(this.currentDiff.transportDiscount - this.currentDiff.discount), isFeeField: true },
        { item: '折扣率', baozun: this.currentDiff.discountRate || '-', transport: this.currentDiff.transportDiscountRate || '-', diff: this.formatDiff(this.currentDiff.transportDiscountRate - this.currentDiff.discountRate), diffClass: this.getDiffClass(this.currentDiff.transportDiscountRate - this.currentDiff.discountRate), isFeeField: true },
        { item: '折后运费(元)', baozun: this.formatCurrency(this.currentDiff.baozunFee), transport: this.formatCurrency(this.currentDiff.transportFee), diff: this.formatCurrency(this.currentDiff.transportFee - this.currentDiff.baozunFee), diffClass: this.getDiffClass(this.currentDiff.transportFee - this.currentDiff.baozunFee), isFeeField: true },
        { item: '返利(元)', baozun: this.formatCurrency(this.currentDiff.rebate), transport: this.formatCurrency(this.currentDiff.transportRebate), diff: this.formatCurrency(this.currentDiff.transportRebate - this.currentDiff.rebate), diffClass: this.getDiffClass(this.currentDiff.transportRebate - this.currentDiff.rebate), isFeeField: true },
        { item: '服务费(元)', baozun: this.formatCurrency(this.currentDiff.serviceFee), transport: this.formatCurrency(this.currentDiff.transportServiceFee), diff: this.formatCurrency(this.currentDiff.transportServiceFee - this.currentDiff.serviceFee), diffClass: this.getDiffClass(this.currentDiff.transportServiceFee - this.currentDiff.serviceFee), isFeeField: true },
        { item: '历史结算费用(元)', baozun: this.formatCurrency(this.currentDiff.historicalSettlementFee), transport: '-', diff: '红冲前已结算费用', diffClass: 'diff-red', isFeeField: true },
        { item: '总费用(元)', baozun: this.formatCurrency(this.currentDiff.baozunFee), transport: this.formatCurrency(this.currentDiff.transportFee), diff: this.formatCurrency(this.currentDiff.transportFee - this.currentDiff.baozunFee), diffClass: this.getDiffClass(this.currentDiff.transportFee - this.currentDiff.baozunFee), isFeeField: true }
      ]
      return data
    },
    canViewFeeFields() {
      const feeRoles = ['物流商', 'IT', '配送组', '财务', '管理员']
      return feeRoles.includes(this.currentUserRole)
    },
    displayCompareData() {
      let data = this.compareData
      if (!this.canViewFeeFields) {
        data = data.filter(item => !item.isFeeField)
      }
      if (this.showFullCompare) {
        return data
      }
      const reason = this.currentDiff.diffReason
      const reasonMap = {
        '计费重量校验': '计费重量(kg)',
        '计费重量差异': '计费重量(kg)',
        '总费用差异': '总费用(元)',
        '标准运费差异': '标准运费(元)',
        '折后运费差异': '折后运费(元)',
        '服务费差异': '服务费(元)',
        '首重报价差异': '首重单价(元)',
        '续重报价差异': '续重单价(元)',
        '逆向月结一口价差异': '总费用(元)',
        '目的地省差异': '目的省',
        '月结账号差异': '月结账号',
        '产品类型差异': '产品类型名称',
        '结算系统不存在': '运单号',
        '红冲运单': '总费用(元)',
        '物流商不存在': '运单号',
        '非宝尊月结': '月结账号',
        '退货运单无批次号': '退货批次号',
        '运单接口不存在': '接口查询状态',
        '运费未正常计算': '标准运费(元)',
        '运单卡接口': '接口下发状态'
      }
      if (reason === '红冲运单') {
        const red冲Rows = data.filter(item => item.item === '总费用(元)' || item.item === '历史结算费用(元)')
        if (red冲Rows.length > 0) {
          return red冲Rows
        }
      }
      const keyField = reasonMap[reason]
      if (keyField && !['运单号', '退货批次号', '接口查询状态', '接口下发状态'].includes(keyField)) {
        const filtered = data.filter(item => item.item === keyField)
        if (filtered.length > 0) {
          return filtered
        }
      }
      if (reason === '结算系统不存在') {
        return [{ item: '运单号', baozun: '-', transport: this.currentDiff.expressNo || '-', diff: '宝尊系统无此运单', diffClass: 'diff-red' }]
      }
      if (reason === '物流商不存在') {
        return [{ item: '运单号', baozun: this.currentDiff.expressNo || '-', transport: '-', diff: '物流商系统无此运单', diffClass: 'diff-red' }]
      }
      if (reason === '退货运单无批次号') {
        return [{ item: '退货批次号', baozun: this.currentDiff.returnBatchNo || '-', transport: '-', diff: '物流商缺失退货批次号', diffClass: 'diff-red' }]
      }
      if (reason === '运单接口不存在') {
        return [{ item: '接口查询状态', baozun: '失败', transport: '-', diff: '宝尊系统未正常查询到运费', diffClass: 'diff-red' }]
      }
      if (reason === '运费未正常计算') {
        return [{ item: '标准运费(元)', baozun: '-', transport: this.formatCurrency(this.currentDiff.transportStandardFee), diff: '宝尊系统计算异常', diffClass: 'diff-red' }]
      }
      if (reason === '运单卡接口') {
        return [{ item: '接口下发状态', baozun: '未下发', transport: '-', diff: '接口未下发成功', diffClass: 'diff-red' }]
      }
      return data.slice(0, 5)
    }
  },
  mounted() {
    this.loadDiffDetail()
  },
  methods: {
    getTextDiff(val1, val2) {
      if (!val1 && !val2) return '-'
      if (!val1 || !val2) return '-'
      return val1 === val2 ? '-' : '不一致'
    },
    getTextDiffClass(val1, val2) {
      if (!val1 && !val2) return 'diff-gray'
      if (!val1 || !val2) return 'diff-gray'
      return val1 === val2 ? 'diff-gray' : 'diff-red'
    },
    toggleSection(section) {
      this.collapsedSections[section] = !this.collapsedSections[section]
    },
    toggleCompareView() {
      this.showFullCompare = !this.showFullCompare
    },
    loadDiffDetail() {
      console.log('loadDiffDetail called')
      console.log('route query:', this.$route.query)
      
      const status = this.$route.query.status || '已处理'
      const diffReason = this.$route.query.diffReason || '计费重量校验'
      const handlerRole = this.$route.query.handlerRole || '物流商'
      const diffBillNo = this.$route.query.diffBillNo || 'CD20240701-003'
      this.fromView = this.$route.query.fromView || 'all'
      
      if (this.$route.query.mode === 'audit') {
        this.initAuditForm(false)
        this.auditMode = true
      }

      const handlerNames = {
        '物流商': '赵六',
        '财务': '张三',
        'IT': '钱七',
        '配送组': '周九',
        'KA': '郑十一',
        '运营': '陈十三'
      }

      const newDiff = {
        diffBillNo: diffBillNo,
        billCycle: '2024-07',
        expressNo: 'YTO1234567890',
        transportName: '圆通快递',
        baozunAccount: 'YZ001',
        transportAccount: 'YZ001',
        productTypeName: '标准快递',
        transportProductType: '标准快递',
        paymentMethod: '月结',
        transportPaymentMethod: '月结',
        baozunWeight: 1.200,
        transportWeight: 1.000,
        actualWeight: 1.150,
        transportActualWeight: 1.150,
        length: 30,
        transportLength: 30,
        width: 20,
        transportWidth: 20,
        height: 15,
        transportHeight: 15,
        volume: 0.009,
        transportVolume: 0.009,
        volumeWeight: 0.300,
        transportVolumeWeight: 0.300,
        lightCoefficient: 6000,
        transportLightCoefficient: 6000,
        originProvince: '上海市',
        transportOriginProvince: '上海市',
        originCity: '上海市',
        transportOriginCity: '上海市',
        originDistrict: '浦东新区',
        transportOriginDistrict: '浦东新区',
        destProvince: '北京市',
        transportDestProvince: '北京市',
        destCity: '北京市',
        transportDestCity: '北京市',
        destDistrict: '朝阳区',
        transportDestDistrict: '朝阳区',
        firstWeightPrice: 12.00,
        transportFirstWeightPrice: 12.00,
        continueWeightPrice: 5.00,
        transportContinueWeightPrice: 5.00,
        standardFee: 15.00,
        transportStandardFee: 15.00,
        discount: 0.85,
        transportDiscount: 0.80,
        discountRate: 0.85,
        transportDiscountRate: 0.80,
        baozunFee: 12.75,
        transportFee: 12.00,
        serviceFee: 2.00,
        transportServiceFee: 2.50,
        historicalSettlementFee: 45.00,
        rebate: 0.50,
        transportRebate: 0.50,
        diffReason: diffReason,
        handlerRole: handlerRole,
        handlerName: handlerNames[handlerRole] || '赵六',
        status: status,
        createTime: '2024-07-01 09:30:00',
        feedbackTime: '2024-07-02 11:15',
        isDefaultRule: false,
        feedbackType: '其他核对结果',
        handleType: '宝尊费用',
        handlerDesc: '经核实，以物流商实际称重1.2kg为准。系统已重新计算运费，确认无误。',
        attachments: ['称重记录.pdf', '运单截图.png'],
        baozunAccount: 'YZ001',
        transportAccount: 'YZ001',
        brand: '品牌A',
        length: 30,
        width: 20,
        height: 15,
        volume: 0.009,
        senderProvince: '上海市',
        senderCity: '上海市',
        senderDistrict: '浦东新区',
        receiverProvince: '北京市',
        receiverCity: '北京市',
        receiverDistrict: '朝阳区',
        firstWeightPrice: 12.00,
        continueWeightPrice: 5.00,
        insuranceFee: 0,
        serviceFee: 2.00,
        productType: '标准快递',
        interceptFlag: '否',
        declaredValue: 1000,
        lightCoefficient: 6000,
        discount: 0.85,
        agreementClause11: null,
        agreementClause12: null,
        agreementClause618: null,
        returnFee: null,
        springFestivalService: null,
        specialAreaSurcharge: null,
        otherFee: null,
        payableAmountFormula: '首重+续重*(计费重量-1)*折扣',
        proofData: { 
          billingWeight: '1.200', 
          actualWeight: '1.150', 
          length: '30',
          width: '20',
          height: '15',
          volume: '0.009',
          senderProvince: '上海市',
          senderCity: '上海市',
          senderDistrict: '浦东新区',
          receiverProvince: '北京市',
          receiverCity: '北京市',
          receiverDistrict: '朝阳区',
          firstWeightPrice: '12.00',
          continueWeightPrice: '5.00',
          standardFreight: '15.00',
          discountedFreight: '12.75',
          insuranceFee: '0.00',
          totalFee: '14.75',
          monthlyAccount: 'YZ001',
          brand: '品牌A',
          interceptFlag: '否',
          lightCoefficient: '6000',
          productType: '标准快递',
          declaredValue: '1000',
          rebate: '0.50',
          returnBatchNo: '',
          serviceFee: '2.00',
          discount: '0.85',
          agreementClause11: '0.00',
          agreementClause12: '0.00',
          agreementClause618: '0.00',
          returnFee: '0.00',
          springFestivalService: '0.00',
          specialAreaSurcharge: '0.00',
          otherFee: '0.00',
          payableAmountFormula: '首重+续重*(计费重量-1)*折扣',
          insuranceFee: '0.00'
        },
        feedback: { feedbackType: '其他核对结果', confirmedWeight: '1.200', handlerDesc: '经核实，以物流商实际称重1.2kg为准。', attachments: ['称重记录.pdf'], feedbackTime: '2024-07-02 11:15' }
      }
      
      console.log('Setting currentDiff:', newDiff)
      this.$set(this, 'currentDiff', newDiff)
      
      this.initHandlerForm()
    },
    initHandlerForm() {
      if (this.isRed冲运单 && this.currentDiff.red冲Amount) {
        this.handlerForm.red冲Amount = this.currentDiff.red冲Amount
      }
    },
    formatCurrency(value) {
      if (value === undefined || value === null) return '0.00'
      return parseFloat(value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatDiff(value) {
      if (value === undefined || value === null) return '0.000'
      const sign = value > 0 ? '+' : ''
      return sign + parseFloat(value).toFixed(3)
    },
    getDiffClass(value) {
      if (value > 0) return 'diff-positive'
      if (value < 0) return 'diff-negative'
      return ''
    },
    getStatusType(status) {
      switch (status) {
        case '待处理': return 'warning'
        case '已处理': return 'primary'
        case '已驳回': return 'danger'
        case '审核通过': return 'success'
        case '已关闭': return 'info'
        default: return 'info'
      }
    },
    goBack() {
      this.$router.push('/cost-diff-handle')
    },
    goAudit() {
      this.initAuditForm(false)
      this.auditMode = true
    },
    initAuditForm(isCopy) {
      if (!isCopy) {
        this.auditForm = {
          feeSource: 'recalc',
          remark: '',
          monthlyAccount: '',
          warehouseCode: '',
          storeCode: '',
          brand: '',
          storeCostCenter: '',
          parkName: '',
          parkCostCenter: '',
          confirmWeight: null,
          confirmActualWeight: null,
          confirmLength: null,
          confirmWidth: null,
          confirmHeight: null,
          confirmVolume: null,
          lightThrowFactor: null,
          senderProvince: '',
          senderCity: '',
          senderDistrict: '',
          receiverProvince: '',
          receiverCity: '',
          receiverDistrict: '',
          serviceFee: null,
          firstWeightPrice: 12,
          continueWeightPrice: 5,
          standardFreight: null,
          discountedFreight: null,
          discount: '',
          agreementClause11: null,
          agreementClause12: null,
          agreementClause618: null,
          returnFee: null,
          springFestivalService: null,
          specialAreaSurcharge: null,
          otherFee: null,
          interceptFlag: '否',
          payableAmountFormula: '',
          productType: '',
          declaredValue: null,
          insuranceFee: null,
          totalFee: null,
          confirmStandardFreight: '0.00',
          confirmDiscountedFreight: '0.00',
          confirmServiceFee: '0.00',
          confirmTotalFee: '0.00',
          confirmRebate: '0.00',
          auditOpinion: '',
          settlementDecision: ''
        }
      }
      
      if (this.currentDiff.proofData) {
        this.auditForm.confirmWeight = parseFloat(this.currentDiff.proofData.billingWeight) || null
        this.auditForm.confirmActualWeight = parseFloat(this.currentDiff.proofData.actualWeight) || null
        this.auditForm.confirmLength = parseFloat(this.currentDiff.proofData.length) || null
        this.auditForm.confirmWidth = parseFloat(this.currentDiff.proofData.width) || null
        this.auditForm.confirmHeight = parseFloat(this.currentDiff.proofData.height) || null
        this.auditForm.confirmVolume = parseFloat(this.currentDiff.proofData.volume) || null
        this.auditForm.lightThrowFactor = parseInt(this.currentDiff.proofData.lightCoefficient) || null
        this.auditForm.firstWeightPrice = parseFloat(this.currentDiff.proofData.firstWeightPrice) || 12
        this.auditForm.continueWeightPrice = parseFloat(this.currentDiff.proofData.continuedWeightPrice) || 5
        this.auditForm.standardFreight = parseFloat(this.currentDiff.proofData.standardFreight) || null
        this.auditForm.discountedFreight = parseFloat(this.currentDiff.proofData.discountedFreight) || null
        this.auditForm.insuranceFee = parseFloat(this.currentDiff.proofData.insuranceFee) || null
        this.auditForm.totalFee = parseFloat(this.currentDiff.proofData.totalFee) || null
        this.auditForm.monthlyAccount = this.currentDiff.proofData.monthlyAccount || ''
        // 品牌随店铺联动带出，仓库/店铺回显时同步带出关联字段
        if (this.currentDiff.proofData.storeCode) {
          this.auditForm.storeCode = this.currentDiff.proofData.storeCode
          this.fillStoreInfo(this.currentDiff.proofData.storeCode)
        }
        if (this.currentDiff.proofData.warehouseCode) {
          this.auditForm.warehouseCode = this.currentDiff.proofData.warehouseCode
          this.fillWarehouseInfo(this.currentDiff.proofData.warehouseCode)
        }
        this.auditForm.senderProvince = this.currentDiff.proofData.senderProvince || ''
        this.auditForm.senderCity = this.currentDiff.proofData.senderCity || ''
        this.auditForm.senderDistrict = this.currentDiff.proofData.senderDistrict || ''
        this.auditForm.receiverProvince = this.currentDiff.proofData.receiverProvince || ''
        this.auditForm.receiverCity = this.currentDiff.proofData.receiverCity || ''
        this.auditForm.receiverDistrict = this.currentDiff.proofData.receiverDistrict || ''
        this.auditForm.productType = this.currentDiff.proofData.productType || ''
        this.auditForm.declaredValue = parseFloat(this.currentDiff.proofData.declaredValue) || null
        this.auditForm.interceptFlag = this.currentDiff.proofData.interceptFlag || '否'
        this.auditForm.payableAmountFormula = this.currentDiff.proofData.payableAmountFormula || ''
        this.auditForm.agreementClause11 = parseFloat(this.currentDiff.proofData.agreementClause11) || null
        this.auditForm.agreementClause12 = parseFloat(this.currentDiff.proofData.agreementClause12) || null
        this.auditForm.agreementClause618 = parseFloat(this.currentDiff.proofData.agreementClause618) || null
        this.auditForm.returnFee = parseFloat(this.currentDiff.proofData.returnFee) || null
        this.auditForm.springFestivalService = parseFloat(this.currentDiff.proofData.springFestivalService) || null
        this.auditForm.specialAreaSurcharge = parseFloat(this.currentDiff.proofData.specialAreaSurcharge) || null
        this.auditForm.otherFee = parseFloat(this.currentDiff.proofData.otherFee) || null
        this.auditForm.serviceFee = parseFloat(this.currentDiff.proofData.serviceFee) || null
      }
      
      if (this.currentDiff.feedback) {
        this.auditForm.confirmStandardFreight = this.formatCurrency(this.currentDiff.feedback.confirmedStandardFreight) || '0.00'
        this.auditForm.confirmDiscountedFreight = this.formatCurrency(this.currentDiff.feedback.confirmedDiscountedFreight) || '0.00'
        this.auditForm.confirmServiceFee = this.formatCurrency(this.currentDiff.feedback.confirmedServiceFee) || '0.00'
        this.auditForm.confirmTotalFee = this.formatCurrency(this.currentDiff.feedback.confirmedTotalFee) || '0.00'
        this.auditForm.confirmRebate = this.formatCurrency(this.currentDiff.feedback.confirmedRebate) || '0.00'
      }
      
      if (this.currentDiff.proofData) {
        const senderProvince = this.currentDiff.proofData.senderProvince || ''
        const senderCity = this.currentDiff.proofData.senderCity || ''
        const senderDistrict = this.currentDiff.proofData.senderDistrict || ''
        const receiverProvince = this.currentDiff.proofData.receiverProvince || ''
        const receiverCity = this.currentDiff.proofData.receiverCity || ''
        const receiverDistrict = this.currentDiff.proofData.receiverDistrict || ''
        
        this.senderAddress = []
        if (senderProvince) this.senderAddress.push(senderProvince)
        if (senderCity && senderCity !== senderProvince) this.senderAddress.push(senderCity)
        if (senderDistrict) this.senderAddress.push(senderDistrict)
        
        this.receiverAddress = []
        if (receiverProvince) this.receiverAddress.push(receiverProvince)
        if (receiverCity && receiverCity !== receiverProvince) this.receiverAddress.push(receiverCity)
        if (receiverDistrict) this.receiverAddress.push(receiverDistrict)
      }
    },
    handleSenderAddressChange(val) {
      this.auditForm.senderProvince = val.length > 0 ? val[0] : ''
      this.auditForm.senderCity = val.length > 1 ? val[1] : ''
      this.auditForm.senderDistrict = val.length > 2 ? val[2] : ''
    },
    handleReceiverAddressChange(val) {
      this.auditForm.receiverProvince = val.length > 0 ? val[0] : ''
      this.auditForm.receiverCity = val.length > 1 ? val[1] : ''
      this.auditForm.receiverDistrict = val.length > 2 ? val[2] : ''
    },
    handleHandlerSenderAddressChange(val) {
      this.handlerForm.proofData.senderProvince = val.length > 0 ? val[0] : ''
      this.handlerForm.proofData.senderCity = val.length > 1 ? val[1] : ''
      this.handlerForm.proofData.senderDistrict = val.length > 2 ? val[2] : ''
    },
    handleHandlerReceiverAddressChange(val) {
      this.handlerForm.proofData.receiverProvince = val.length > 0 ? val[0] : ''
      this.handlerForm.proofData.receiverCity = val.length > 1 ? val[1] : ''
      this.handlerForm.proofData.receiverDistrict = val.length > 2 ? val[2] : ''
    },
    handleFeeSourceChange(val) {
      if (val !== 'recalc') {
        this.copyCurrentFee()
      }
    },
    onAuditWarehouseChange(code) {
      this.fillWarehouseInfo(code)
    },
    fillWarehouseInfo(code) {
      const warehouse = this.warehouseOptions.find(item => item.warehouseCode === code)
      // 园区、园区成本中心由仓库关联带出，仅展示不可改
      this.auditForm.parkName = warehouse ? warehouse.parkName : ''
      this.auditForm.parkCostCenter = warehouse ? warehouse.parkCostCenter : ''
    },
    onAuditStoreChange(code) {
      this.fillStoreInfo(code)
    },
    fillStoreInfo(code) {
      const store = this.storeOptions.find(item => item.storeCode === code)
      // 品牌、店铺成本中心由店铺关联带出，仅展示不可改
      this.auditForm.brand = store ? store.brand : ''
      this.auditForm.storeCostCenter = store ? store.costCenter : ''
    },
    copyCurrentFee() {
      const feeSource = this.auditForm.feeSource
      if (feeSource === 'baozun') {
        this.auditForm.confirmWeight = this.currentDiff.baozunWeight
        this.auditForm.confirmActualWeight = this.currentDiff.baozunWeight
        this.auditForm.confirmLength = this.currentDiff.length
        this.auditForm.confirmWidth = this.currentDiff.width
        this.auditForm.confirmHeight = this.currentDiff.height
        this.auditForm.confirmVolume = this.currentDiff.volume
        this.auditForm.lightThrowFactor = this.currentDiff.lightCoefficient
        this.auditForm.senderProvince = this.currentDiff.senderProvince
        this.auditForm.senderCity = this.currentDiff.senderCity
        this.auditForm.senderDistrict = this.currentDiff.senderDistrict
        this.auditForm.receiverProvince = this.currentDiff.receiverProvince
        this.auditForm.receiverCity = this.currentDiff.receiverCity
        this.auditForm.receiverDistrict = this.currentDiff.receiverDistrict
        
        this.senderAddress = []
        if (this.currentDiff.senderProvince) this.senderAddress.push(this.currentDiff.senderProvince)
        if (this.currentDiff.senderCity && this.currentDiff.senderCity !== this.currentDiff.senderProvince) this.senderAddress.push(this.currentDiff.senderCity)
        if (this.currentDiff.senderDistrict) this.senderAddress.push(this.currentDiff.senderDistrict)
        
        this.receiverAddress = []
        if (this.currentDiff.receiverProvince) this.receiverAddress.push(this.currentDiff.receiverProvince)
        if (this.currentDiff.receiverCity && this.currentDiff.receiverCity !== this.currentDiff.receiverProvince) this.receiverAddress.push(this.currentDiff.receiverCity)
        if (this.currentDiff.receiverDistrict) this.receiverAddress.push(this.currentDiff.receiverDistrict)
        this.auditForm.monthlyAccount = this.currentDiff.baozunAccount
        this.auditForm.brand = this.currentDiff.brand
        this.auditForm.productType = this.currentDiff.productType
        this.auditForm.interceptFlag = this.currentDiff.interceptFlag
        this.auditForm.declaredValue = this.currentDiff.declaredValue
        this.auditForm.firstWeightPrice = this.currentDiff.firstWeightPrice
        this.auditForm.continueWeightPrice = this.currentDiff.continueWeightPrice
        this.auditForm.standardFreight = this.currentDiff.standardFee
        this.auditForm.discountedFreight = this.currentDiff.baozunFee
        this.auditForm.insuranceFee = this.currentDiff.insuranceFee
        this.auditForm.serviceFee = this.currentDiff.serviceFee
        this.auditForm.agreementClause11 = this.currentDiff.agreementClause11
        this.auditForm.agreementClause12 = this.currentDiff.agreementClause12
        this.auditForm.agreementClause618 = this.currentDiff.agreementClause618
        this.auditForm.returnFee = this.currentDiff.returnFee
        this.auditForm.springFestivalService = this.currentDiff.springFestivalService
        this.auditForm.specialAreaSurcharge = this.currentDiff.specialAreaSurcharge
        this.auditForm.otherFee = this.currentDiff.otherFee
        this.auditForm.totalFee = this.currentDiff.baozunFee
        this.auditForm.payableAmountFormula = this.currentDiff.payableAmountFormula
        this.auditForm.confirmStandardFreight = this.formatCurrency(this.currentDiff.standardFee)
        this.auditForm.confirmDiscountedFreight = this.formatCurrency(this.currentDiff.baozunFee)
        this.auditForm.confirmServiceFee = this.formatCurrency(this.currentDiff.serviceFee)
        this.auditForm.confirmTotalFee = this.formatCurrency(this.currentDiff.baozunFee)
        this.auditForm.confirmRebate = '0.00'
      } else if (feeSource === 'transport') {
        this.auditForm.confirmWeight = this.currentDiff.transportWeight
        this.auditForm.confirmActualWeight = this.currentDiff.transportWeight
        this.auditForm.confirmLength = this.currentDiff.length
        this.auditForm.confirmWidth = this.currentDiff.width
        this.auditForm.confirmHeight = this.currentDiff.height
        this.auditForm.confirmVolume = this.currentDiff.volume
        this.auditForm.lightThrowFactor = this.currentDiff.lightCoefficient
        this.auditForm.senderProvince = this.currentDiff.senderProvince
        this.auditForm.senderCity = this.currentDiff.senderCity
        this.auditForm.senderDistrict = this.currentDiff.senderDistrict
        this.auditForm.receiverProvince = this.currentDiff.receiverProvince
        this.auditForm.receiverCity = this.currentDiff.receiverCity
        this.auditForm.receiverDistrict = this.currentDiff.receiverDistrict
        
        this.senderAddress = []
        if (this.currentDiff.senderProvince) this.senderAddress.push(this.currentDiff.senderProvince)
        if (this.currentDiff.senderCity && this.currentDiff.senderCity !== this.currentDiff.senderProvince) this.senderAddress.push(this.currentDiff.senderCity)
        if (this.currentDiff.senderDistrict) this.senderAddress.push(this.currentDiff.senderDistrict)
        
        this.receiverAddress = []
        if (this.currentDiff.receiverProvince) this.receiverAddress.push(this.currentDiff.receiverProvince)
        if (this.currentDiff.receiverCity && this.currentDiff.receiverCity !== this.currentDiff.receiverProvince) this.receiverAddress.push(this.currentDiff.receiverCity)
        if (this.currentDiff.receiverDistrict) this.receiverAddress.push(this.currentDiff.receiverDistrict)
        
        this.auditForm.monthlyAccount = this.currentDiff.transportAccount
        this.auditForm.brand = this.currentDiff.brand
        this.auditForm.productType = this.currentDiff.productType
        this.auditForm.interceptFlag = this.currentDiff.interceptFlag
        this.auditForm.declaredValue = this.currentDiff.declaredValue
        this.auditForm.firstWeightPrice = this.currentDiff.firstWeightPrice
        this.auditForm.continueWeightPrice = this.currentDiff.continueWeightPrice
        this.auditForm.standardFreight = this.currentDiff.transportStandardFee
        this.auditForm.discountedFreight = this.currentDiff.transportFee
        this.auditForm.insuranceFee = this.currentDiff.insuranceFee
        this.auditForm.serviceFee = this.currentDiff.transportServiceFee
        this.auditForm.agreementClause11 = this.currentDiff.agreementClause11
        this.auditForm.agreementClause12 = this.currentDiff.agreementClause12
        this.auditForm.agreementClause618 = this.currentDiff.agreementClause618
        this.auditForm.returnFee = this.currentDiff.returnFee
        this.auditForm.springFestivalService = this.currentDiff.springFestivalService
        this.auditForm.specialAreaSurcharge = this.currentDiff.specialAreaSurcharge
        this.auditForm.otherFee = this.currentDiff.otherFee
        this.auditForm.totalFee = this.currentDiff.transportFee
        this.auditForm.payableAmountFormula = this.currentDiff.payableAmountFormula
        this.auditForm.confirmStandardFreight = this.formatCurrency(this.currentDiff.transportStandardFee)
        this.auditForm.confirmDiscountedFreight = this.formatCurrency(this.currentDiff.transportFee)
        this.auditForm.confirmServiceFee = this.formatCurrency(this.currentDiff.transportServiceFee)
        this.auditForm.confirmTotalFee = this.formatCurrency(this.currentDiff.transportFee)
        this.auditForm.confirmRebate = '0.00'
      }
    },
    recalcFees() {
      const weight = this.auditForm.confirmWeight || 0
      const firstPrice = this.auditForm.firstWeightPrice || 12
      const continuePrice = this.auditForm.continueWeightPrice || 5
      
      let standardFreight = firstPrice
      if (weight > 1) {
        standardFreight = firstPrice + (weight - 1) * continuePrice
      }
      
      this.auditForm.standardFreight = parseFloat(standardFreight.toFixed(2))
      
      const discount = parseFloat(this.auditForm.discount) || 1
      const discountedFreight = parseFloat((this.auditForm.standardFreight * discount).toFixed(2))
      
      this.auditForm.confirmStandardFreight = this.formatCurrency(this.auditForm.standardFreight)
      this.auditForm.confirmDiscountedFreight = this.formatCurrency(discountedFreight)
      this.auditForm.confirmServiceFee = '0.00'
      this.auditForm.confirmTotalFee = this.formatCurrency(discountedFreight)
      this.auditForm.confirmRebate = '0.00'
    },
    showForwardDialog() {
      this.forwardForm = { handlerRole: '', handlerName: '', reason: '' }
      this.forwardDialogVisible = true
    },
    onHandlerRoleChange(val) {
      this.availableHandlers = this.handlerUsers[val] || []
      this.forwardForm.handlerName = ''
    },
    handleForward() {
      this.$message.success('转发成功')
      this.forwardDialogVisible = false
    },
    showHandleDialog() {
        this.handlerForm = {
          feedbackType: '',
          confirmedWeight: '',
          returnBatchNo: '',
          handlerDesc: '',
          attachments: [],
          handleType: '',
          red冲Amount: null,
          forwardReason: '',
          senderAddress: [],
          receiverAddress: [],
          proofData: {
            billingWeight: null,
            actualWeight: null,
            length: null,
            width: null,
            height: null,
            volume: null,
            lightThrowFactor: null,
            senderProvince: '',
            senderCity: '',
            senderDistrict: '',
            receiverProvince: '',
            receiverCity: '',
            receiverDistrict: '',
            firstWeightPrice: null,
            continueWeightPrice: null,
            standardFreight: null,
            discount: null,
            agreementClause11: null,
            agreementClause12: null,
            agreementClause618: null,
            returnFee: null,
            springFestivalService: null,
            specialAreaSurcharge: null,
            otherFee: null,
            discountedFreight: null,
            totalFee: null,
            interceptFlag: '否',
            payableAmountFormula: '',
            productType: '',
            declaredValue: null,
            rebate: null,
            monthlyAccount: '',
            remark: ''
          }
        }
        this.handleDialogVisible = true
      },
      handleFeedbackTypeChange(value) {
        if (value === '其他核对结果' && this.currentDiff.proofData) {
          Object.assign(this.handlerForm.proofData, this.currentDiff.proofData)
          
          // 初始化寄件地址级联选择器
          this.handlerForm.senderAddress = []
          if (this.currentDiff.proofData.senderProvince) this.handlerForm.senderAddress.push(this.currentDiff.proofData.senderProvince)
          if (this.currentDiff.proofData.senderCity && this.currentDiff.proofData.senderCity !== this.currentDiff.proofData.senderProvince) this.handlerForm.senderAddress.push(this.currentDiff.proofData.senderCity)
          if (this.currentDiff.proofData.senderDistrict) this.handlerForm.senderAddress.push(this.currentDiff.proofData.senderDistrict)
          
          // 初始化收件地址级联选择器
          this.handlerForm.receiverAddress = []
          if (this.currentDiff.proofData.receiverProvince) this.handlerForm.receiverAddress.push(this.currentDiff.proofData.receiverProvince)
          if (this.currentDiff.proofData.receiverCity && this.currentDiff.proofData.receiverCity !== this.currentDiff.proofData.receiverProvince) this.handlerForm.receiverAddress.push(this.currentDiff.proofData.receiverCity)
          if (this.currentDiff.proofData.receiverDistrict) this.handlerForm.receiverAddress.push(this.currentDiff.proofData.receiverDistrict)
        }
      },
    submitHandle() {
      this.$message.success('处理成功')
      this.handleDialogVisible = false
    },
    showRejectDialog() {
      this.rejectReason = ''
      this.$prompt('请输入驳回原因', '驳回确认', { confirmButtonText: '确定', cancelButtonText: '取消', inputValidator: (value) => { if (!value) return '请输入驳回原因' } }).then(({ value }) => {
        this.rejectReason = value
        this.$message.success('驳回成功')
      }).catch(() => {})
    },
    confirmAuditPass() {
      const requiredFields = [
        { key: 'confirmWeight', label: '计费重量(kg)' },
        { key: 'confirmActualWeight', label: '实际重量(kg)' },
        { key: 'confirmLength', label: '长(cm)' },
        { key: 'confirmWidth', label: '宽(cm)' },
        { key: 'confirmHeight', label: '高(cm)' },
        { key: 'confirmVolume', label: '体积(cm³)' },
        { key: 'senderProvince', label: '寄件省' },
        { key: 'senderCity', label: '寄件市' },
        { key: 'receiverProvince', label: '收件省' },
        { key: 'receiverCity', label: '收件市' },
        { key: 'firstWeightPrice', label: '首重单价(元)' },
        { key: 'continueWeightPrice', label: '续重单价(元)' },
        { key: 'standardFreight', label: '标准运费(元)' },
        { key: 'discountedFreight', label: '折后运费(元)' },
        { key: 'totalFee', label: '总费用(元)' },
        { key: 'monthlyAccount', label: '月结账号' },
        { key: 'warehouseCode', label: '仓库' },
        { key: 'storeCode', label: '店铺（品牌根据店铺关联带出）' }
      ]
      
      const missingFields = requiredFields.filter(field => {
        const value = this.auditForm[field.key]
        return value === null || value === undefined || value === ''
      })
      
      if (missingFields.length > 0) {
        this.$message.warning(`请填写必填字段：${missingFields.map(f => f.label).join('、')}`)
        return
      }
      
      this.$confirm('确认审核通过？', '审核确认', { confirmButtonText: '确定', cancelButtonText: '取消' }).then(() => {
        this.$message.success('审核通过')
        this.auditMode = false
      }).catch(() => {})
    },
    confirmClose() {
      this.$message.success('单据已关闭')
      this.confirmDialogVisible = false
    },
    exportInterfaceData() {
      this.$message.success('导出成功')
    },
    exportOperationLogs() {
      this.$message.success('导出成功')
    },
    checkUrlParams() {
      if (this.$route.query.auditMode === 'true') {
        this.auditMode = true
      }
    }
  }
}
</script>

<style scoped>
.cost-diff-detail-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.expandable-section {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
  background: #fafafa;
  border-radius: 8px 8px 0 0;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.section-toggle {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #606266;
}

.section-content {
  padding: 20px;
}

.four-col-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.grid-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.grid-item.full-width {
  grid-column: span 4;
}

.grid-item .label {
  font-size: 13px;
  color: #606266;
}

.grid-item .value {
  font-size: 14px;
  color: #303133;
}

.grid-item .form-control {
  width: 100%;
}

.sub-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin: 20px 0 12px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #409eff;
  margin: 16px 0 12px;
  padding: 8px 12px;
  background-color: #ecf5ff;
  border-radius: 4px;
  grid-column: span 4;
}

.compare-table-wrapper {
  margin-bottom: 12px;
}

.compare-table {
  font-size: 13px;
}

.expand-btn {
  float: right;
}

.diff-positive {
  color: #67c23a;
}

.diff-negative {
  color: #f56c6c;
}

.feedback-detail {
  margin-top: 16px;
}

.detail-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.detail-label {
  font-size: 13px;
  color: #606266;
  flex-shrink: 0;
}

.detail-value {
  font-size: 13px;
  color: #303133;
}

.attachment-link {
  margin-right: 12px;
  color: #409eff;
  cursor: pointer;
}

.expandable-sub-section {
  margin-top: 16px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.sub-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #fafafa;
  border-radius: 6px 6px 0 0;
  cursor: pointer;
}

.sub-section-title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
}

.sub-section-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #606266;
}

.sub-section-content {
  padding: 16px;
}

.tabs-container {
  margin-top: 20px;
}

.detail-tabs {
  margin-bottom: 0;
}

.detail-tabs /deep/ .el-tabs__header {
  margin-bottom: 0;
}

.detail-tabs /deep/ .el-tabs__content {
  padding: 16px;
  border: 1px solid #e4e7ed;
  border-top: none;
  min-height: 200px;
}

.tab-content-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.required-asterisk {
  color: #f56c6c;
  margin-right: 4px;
}

.audit-tip {
  font-size: 13px;
  color: #909399;
  margin-bottom: 16px;
  padding: 12px;
  background: #fef9f0;
  border-radius: 4px;
}

.audit-form {
  margin-top: 16px;
}

.action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 15px;
  background: #fff;
  box-shadow: 0 -2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.dialog-footer {
  text-align: right;
}

.reject-record {
  margin-bottom: 20px;
  padding: 16px;
  background: #fef0f0;
  border-radius: 6px;
}

.reject-record-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #f56c6c;
  margin-bottom: 12px;
}

.reject-record-content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.reject-record-item {
  display: flex;
  gap: 8px;
}

.reject-label {
  font-size: 13px;
  color: #606266;
}

.reject-value {
  font-size: 13px;
  color: #303133;
}

.summary-info {
  margin-bottom: 20px;
  padding: 16px;
  background: #fafafa;
  border-radius: 6px;
}

.summary-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.summary-row:last-child {
  margin-bottom: 0;
}

.summary-label {
  font-size: 13px;
  color: #606266;
  flex-shrink: 0;
}

.summary-value {
  font-size: 13px;
  color: #303133;
}

.required-mark {
  color: #f56c6c;
  margin-right: 4px;
}

.handle-form {
  max-height: 60vh;
  overflow-y: auto;
}

.upload-tip {
  margin-left: 8px;
  font-size: 12px;
  color: #909399;
}

.confirm-content {
  padding: 16px;
}

.confirm-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.info-item {
  display: flex;
  gap: 8px;
}

.info-item .label {
  font-size: 13px;
  color: #606266;
}

.info-item .value {
  font-size: 13px;
  color: #303133;
}

@media (max-width: 1200px) {
  .four-col-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 900px) {
  .four-col-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .four-col-grid {
    grid-template-columns: 1fr;
  }
}
</style>